/* ==========================================================================
   Paradermia — Bilan Micro-Nutrition (JS)

   Architecture en miroir du quiz peau (assets/quiz-paradermia.js).
   Réutilise exactement les classes CSS pd-welcome, pd-question, pd-option,
   pd-transition-1, pd-bifurcation, pd-email-capture pour bénéficier du
   stylage déjà raffiné. quiz-nutrition.css override la palette
   #88cc40 → #C9A84C et ajoute les composants spécifiques nutrition
   (chips déjà pris, cards actifs, protocole 3 phases).

   Mono-page : SAS → Partie 1 → Partie 2 → Email → Loading 1 → Résultats
   partiels → Bifurcation → Partie 3 → Loading 2 → Résultats complets.

   Pas de localStorage : variables JS globales.
   ========================================================================== */

(function () {
  'use strict';

  // ── 2026-10-06 — Klaviyo sans script onsite ──────────────────────────────
  // Constat (audit) : paradermia.com ne charge pas klaviyo.js, donc les
  // window._learnq.push(...) des quiz n'étaient lus par personne (aucun
  // événement quiz depuis le 25/05/2026). Ce shim transforme les push
  // ['identify'|'track'] en appels à l'API client Klaviyo (clé publique
  // company_id, aucun secret). Si klaviyo.js est un jour chargé
  // (window.klaviyo défini), le shim s'efface et laisse faire le natif.
  (function () {
    var CID = 'SM95Gk';
    if (window.__pdKlaviyoShim || window.klaviyo) return;
    window.__pdKlaviyoShim = true;
    function anon() {
      try {
        var k = 'pd_anon_id', v = localStorage.getItem(k);
        if (!v) { v = 'pd-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10); localStorage.setItem(k, v); }
        return v;
      } catch (_) { return 'pd-' + Date.now(); }
    }
    var ident = {};
    function send(path, data) {
      try {
        fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + CID, {
          method: 'POST', keepalive: true,
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({ data: data })
        }).catch(function () {});
      } catch (_) {}
    }
    function profileAttrs(extra) {
      var a = Object.assign({}, extra || {}), out = {};
      if (a.$email) { out.email = a.$email; delete a.$email; }
      if (a.$first_name) { out.first_name = a.$first_name; delete a.$first_name; }
      if (a.$last_name) { out.last_name = a.$last_name; delete a.$last_name; }
      if (ident.email && !out.email) out.email = ident.email;
      if (ident.first_name && !out.first_name) out.first_name = ident.first_name;
      if (!out.email) out.anonymous_id = anon();
      var props = {};
      Object.keys(a).forEach(function (k) { if (k.charAt(0) !== '$' && a[k] !== undefined) props[k] = a[k]; });
      if (Object.keys(props).length) out.properties = props;
      return out;
    }
    var q = { push: function (cmd) {
      try {
        if (!Array.isArray(cmd)) return;
        if (cmd[0] === 'identify') {
          var pa = profileAttrs(cmd[1]);
          if (pa.email) ident.email = pa.email;
          if (pa.first_name) ident.first_name = pa.first_name;
          send('profiles', { type: 'profile', attributes: pa });
        } else if (cmd[0] === 'track') {
          send('events', { type: 'event', attributes: {
            properties: Object.assign({ source_page: location.pathname }, cmd[2] || {}),
            metric: { data: { type: 'metric', attributes: { name: String(cmd[1]) } } },
            profile: { data: { type: 'profile', attributes: profileAttrs() } }
          } });
        }
      } catch (_) {}
    } };
    var existing = window._learnq;
    if (Array.isArray(existing)) existing.forEach(function (c) { q.push(c); });
    window._learnq = q;
  })();

  // ── Cercle ParaDermia : case de consentement (30/10/2026) ──────────────
  // Case NON cochée par défaut (CNIL). Cochée → inscription marketing à la
  // liste Klaviyo « Cercle ParaDermia » (WCbzsz, simple opt-in) via l'API
  // client publique, ce qui déclenche la série de bienvenue (code -10 %).
  function pdCercleBox() {
    var l = document.createElement('label');
    l.className = 'pd-consent';
    l.style.cssText = 'display:flex;gap:10px;align-items:flex-start;text-align:left;font-size:13px;line-height:1.45;margin:4px 0 2px;cursor:pointer;opacity:.92';
    var c = document.createElement('input');
    c.type = 'checkbox'; c.name = 'pd_cercle';
    c.style.cssText = 'margin-top:3px;width:18px;height:18px;flex:0 0 18px;accent-color:#1e3d10';
    var s = document.createElement('span');
    s.textContent = 'Je rejoins le Cercle ParaDermia : je reçois mon code −10 % (dès 45 € d’achat) et les conseils de notre pharmacienne par e-mail. Désinscription en un clic.';
    l.appendChild(c); l.appendChild(s);
    return l;
  }
  function pdCercleSubscribe(form, email, firstName, source) {
    try {
      var c = form && form.querySelector('input[name="pd_cercle"]');
      if (!c || !c.checked || !email) return false;
      var a = { email: email };
      if (firstName) a.first_name = firstName;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=SM95Gk', {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: a } } }, relationships: { list: { data: { type: 'list', id: 'WCbzsz' } } } } }),
      }).catch(function () {});
      try { localStorage.setItem('pd_cercle_sub', '1'); } catch (_) {}
      return true;
    } catch (e) { return false; }
  }


  // ============================================================
  // 1. CATALOGUE DES 21 ACTIFS
  // ============================================================
  const CATALOGUE = {
    vitamine_d: {
      key: 'vitamine_d', nom: 'Vitamine D3', produit: 'Vitamine D3 1000 UI',
      handle: 'vitamine-d3', prix_indicatif: 22,
      why: 'Soutient l\'immunité, l\'humeur et la minéralisation osseuse. Carence quasi systématique en France.',
      forme: 'Gouttes huile', dosage: '1000 UI', moment: 'Matin avec repas', duree: '3 mois',
    },
    magnesium: {
      key: 'magnesium', nom: 'Magnésium', produit: 'Magnésium bisglycinate',
      handle: 'magnesium-bisglycinate', prix_indicatif: 26,
      why: 'Détend le système nerveux, réduit les tensions musculaires et favorise un sommeil profond.',
      forme: 'Gélule', dosage: '300 mg', moment: 'Soir au coucher', duree: '2-3 mois',
    },
    omega3: {
      key: 'omega3', nom: 'Oméga-3', produit: 'Oméga-3 EPA/DHA',
      handle: 'omega-3-epa-dha', prix_indicatif: 32,
      why: 'EPA/DHA d\'origine marine — soutien cardio, cognitif, anti-inflammatoire général.',
      forme: 'Capsule huile', dosage: '1000 mg', moment: 'Midi avec repas', duree: '3 mois',
      ci_anticoag: true,
    },
    omega3_algue: {
      key: 'omega3_algue', nom: 'Oméga-3 algue', produit: 'Oméga-3 d\'algue (vegan)',
      handle: 'omega-3-algue', prix_indicatif: 38,
      why: 'EPA/DHA végétal pour profils végétariens/vegan, sans poisson.',
      forme: 'Capsule', dosage: '500 mg', moment: 'Midi avec repas', duree: '3 mois',
      ci_anticoag: true,
    },
    zinc: {
      key: 'zinc', nom: 'Zinc', produit: 'Zinc bisglycinate',
      handle: 'zinc-bisglycinate', prix_indicatif: 18,
      why: 'Co-facteur de la peau, des phanères, de la fertilité et de l\'immunité.',
      forme: 'Gélule', dosage: '15 mg', moment: 'Soir à jeun', duree: '2 mois',
    },
    fer_femme: {
      key: 'fer_femme', nom: 'Fer', produit: 'Fer bisglycinate',
      handle: 'fer-bisglycinate', prix_indicatif: 24,
      why: 'À envisager si signaux de carence (fatigue, froid, cycles abondants). Bilan ferritine recommandé avant cure.',
      forme: 'Gélule', dosage: '14 mg', moment: 'Matin à jeun', duree: '3 mois',
    },
    b12: {
      key: 'b12', nom: 'Vitamine B12', produit: 'Vitamine B12 méthyl',
      handle: 'vitamine-b12', prix_indicatif: 19,
      why: 'Indispensable au métabolisme énergétique et au système nerveux. Critique chez les vegans.',
      forme: 'Comprimé sublingual', dosage: '1000 µg', moment: 'Matin', duree: '2-3 mois',
    },
    probiotiques: {
      key: 'probiotiques', nom: 'Probiotiques', produit: 'Probiotiques 30 milliards',
      handle: 'probiotiques-30-milliards', prix_indicatif: 36,
      why: 'Souches multiples pour rééquilibrer le microbiote intestinal et soutenir l\'immunité.',
      forme: 'Gélule gastro-résistante', dosage: '30 mds UFC', moment: 'Matin à jeun', duree: '2 mois',
    },
    vitamine_c: {
      key: 'vitamine_c', nom: 'Vitamine C', produit: 'Vitamine C liposomale',
      handle: 'vitamine-c-liposomale', prix_indicatif: 28,
      why: 'Antioxydant, soutien immunitaire, co-facteur du collagène.',
      forme: 'Capsule liposomale', dosage: '500 mg', moment: 'Matin avec repas', duree: '2-3 mois',
      ci_anticoag: true,
    },
    collagene: {
      key: 'collagene', nom: 'Collagène', produit: 'Collagène marin hydrolysé',
      handle: 'collagene-marin', prix_indicatif: 42,
      why: 'Peptides bioactifs pour la peau, les ongles, les articulations.',
      forme: 'Poudre', dosage: '10 g', moment: 'Matin à jeun', duree: '3 mois',
    },
    ashwagandha: {
      key: 'ashwagandha', nom: 'Ashwagandha', produit: 'Ashwagandha KSM-66',
      handle: 'ashwagandha-ksm66', prix_indicatif: 34,
      why: 'Adaptogène — module la réponse au stress chronique et soutient l\'énergie.',
      forme: 'Gélule', dosage: '600 mg', moment: 'Soir', duree: '2 mois',
      ci_grossesse: true, ci_projet_grossesse: true, ci_psy: true, ci_thyroide: true,
    },
    coq10: {
      key: 'coq10', nom: 'CoQ10', produit: 'CoQ10 ubiquinol',
      handle: 'coq10-ubiquinol', prix_indicatif: 44,
      why: 'Énergie cellulaire mitochondriale. Pertinent après 35 ans et chez les sportifs.',
      forme: 'Capsule huile', dosage: '100 mg', moment: 'Midi avec repas', duree: '3 mois',
      ci_anticoag: true, ci_hta: true,
    },
    vitamine_b: {
      key: 'vitamine_b', nom: 'Complexe B', produit: 'Complexe vitamines B',
      handle: 'complexe-b', prix_indicatif: 24,
      why: 'B1, B2, B5, B6, B9, B12 — métabolisme énergétique et nerveux complet.',
      forme: 'Gélule', dosage: '50 mg', moment: 'Matin', duree: '2-3 mois',
    },
    melatonine: {
      key: 'melatonine', nom: 'Mélatonine', produit: 'Mélatonine 1mg',
      handle: 'melatonine-1mg', prix_indicatif: 16,
      why: 'Aide à l\'endormissement et à la régulation du rythme circadien.',
      forme: 'Comprimé', dosage: '1 mg', moment: '30 min avant coucher', duree: 'Cure courte 3-4 sem',
    },
    inositol: {
      key: 'inositol', nom: 'Inositol', produit: 'Myo-inositol',
      handle: 'myo-inositol', prix_indicatif: 30,
      why: 'Soutien de la sensibilité à l\'insuline et de l\'équilibre hormonal féminin (SOPK).',
      forme: 'Poudre', dosage: '2 g', moment: 'Matin et soir', duree: '3 mois',
    },
    calcium: {
      key: 'calcium', nom: 'Calcium', produit: 'Calcium citrate',
      handle: 'calcium-citrate', prix_indicatif: 22,
      why: 'Minéralisation osseuse, particulièrement pertinent en péri-ménopause.',
      forme: 'Comprimé', dosage: '500 mg', moment: 'Soir', duree: '3 mois',
      ci_anticoag: true,
    },
    curcuma: {
      key: 'curcuma', nom: 'Curcuma', produit: 'Curcuma + pipérine',
      handle: 'curcuma-piperine', prix_indicatif: 28,
      why: 'Anti-inflammatoire articulaire et digestif, biodisponibilité accrue par la pipérine.',
      forme: 'Gélule', dosage: '500 mg', moment: 'Avec repas gras', duree: '2-3 mois',
      ci_anticoag: true,
    },
    spiruline: {
      key: 'spiruline', nom: 'Spiruline', produit: 'Spiruline bio',
      handle: 'spiruline-bio', prix_indicatif: 22,
      why: 'Source végétale de fer, B12 partiel, protéines complètes.',
      forme: 'Comprimé', dosage: '3 g', moment: 'Matin', duree: '2 mois',
    },
    zinc_selenium: {
      key: 'zinc_selenium', nom: 'Zinc-Sélénium', produit: 'Zinc + Sélénium',
      handle: 'zinc-selenium', prix_indicatif: 26,
      why: 'Synergie pour la santé prostatique, la fertilité masculine et la thyroïde.',
      forme: 'Gélule', dosage: '15 mg + 100 µg', moment: 'Matin avec repas', duree: '2-3 mois',
    },
    tribulus_maca: {
      key: 'tribulus_maca', nom: 'Tribulus + Maca', produit: 'Tribulus + Maca',
      handle: 'tribulus-maca', prix_indicatif: 36,
      why: 'Soutien de la libido, de la vitalité et de la performance physique.',
      forme: 'Gélule', dosage: '500 mg', moment: 'Matin', duree: '2 mois',
      ci_grossesse: true, ci_projet_grossesse: true,
    },
    vitex: {
      key: 'vitex', nom: 'Vitex', produit: 'Vitex agnus-castus',
      handle: 'vitex-gattilier', prix_indicatif: 26,
      why: 'Régulation hormonale féminine — cycles irréguliers, syndrome prémenstruel.',
      forme: 'Gélule', dosage: '200 mg', moment: 'Matin', duree: '3 mois',
      ci_grossesse: true, ci_projet_grossesse: true, ci_hormonal: true,
    },
  };

  // ============================================================
  // 1b. CONSTANTES : MENTIONS LÉGALES & FER CONDITIONNEL
  // ============================================================
  const FER_CONDITIONNEL_TEXT =
    'Un bilan sanguin (ferritine) est recommandé avant de démarrer une supplémentation en fer. Ne pas prendre sans avis médical.';

  const MENTION_LEGALE_TEXT =
    'Ce bilan nutritionnel est réalisé à titre indicatif et ne constitue pas un diagnostic médical. En cas de pathologie, de traitement en cours ou de doute, consultez un professionnel de santé avant de démarrer une supplémentation.';

  const OBJECTIF_LABELS = {
    energie:          'Énergie',
    immunite:         'Immunité',
    sommeil:          'Sommeil',
    hormonal_cycle:   'Équilibre hormonal',
    peau_phaneres:    'Peau & Phanères',
    digestion:        'Digestion',
    articulations:    'Articulations',
    concentration:    'Concentration',
    vitalite_femme:   'Vitalité féminine',
    sport:            'Sport & Récupération',
    projet_grossesse: 'Projet Grossesse',
    vitalite_homme:   'Vitalité masculine',
    libido:           'Libido & Performance',
    fertilite_homme:  'Fertilité masculine',
    vitalite_neutre:  'Vitalité & Libido',
  };

  // ============================================================
  // 2. ÉTAT GLOBAL
  // ============================================================
  // Indices de fin de partie (0-based) — Q5b ajoutée en position 5 (Partie 1)
  const PARTIE_1_END = 5;        // Q5b (compléments format) — fin Partie 1
  const PARTIE_2_END = 10;       // Q10 (sport) — fin Partie 2 → email
  const PARTIE_3_END = 15;       // Q15 (cycle/digestion) — fin Partie 3 → loading2
  const AUTOADV_DELAY = 300;
  const RESULTATS_PAGE_URL = '/pages/bilan-nutrition-resultats';
  const SS_BILAN_KEY = 'pdn_bilan_result';

  let state = null;
  let app = null;
  let _advanceTimer = null;
  let _catalogueRemote = null;

  function defaultState() {
    return {
      cursor: 0,
      answers: {},
      // sas | questions | email | loading1 | reveal | bifurcation | results-partial | loading2 | results-complete
      mode: 'sas',
      parcours: 'partiel', // partiel | complet
      intro_choice: null,  // V3.34e — 'rapide' | 'complet', choisi dès l'intro (renderSas)
      email: '',
      firstName: '',
      selectedActifs: {},
      submittedKlaviyo: false,
      depuisQuizPeau: false,
      _result: null,
      _questionsCache: null,
    };
  }

  // ============================================================
  // 2b. PRÉ-REMPLISSAGE depuis URL params (from=quiz_peau&...)
  // ============================================================
  // Mappings des paramètres URL vers les valeurs internes du state.
  // Si paramètre manquant ou invalide → on ignore silencieusement.
  function applyUrlPrefill() {
    let params;
    try { params = new URLSearchParams(window.location.search); } catch (_) { return; }
    const from = params.get('from');
    if (from === 'quiz_peau') state.depuisQuizPeau = true;

    // Genre (Q3) : femme | homme | neutre
    const genre = (params.get('genre') || '').toLowerCase();
    if (['femme', 'homme', 'neutre'].includes(genre)) state.answers.Q3 = genre;

    // Grossesse (Q1) : true → enceinte ; false → aucune. Sinon ignorer.
    const grossesse = (params.get('grossesse') || '').toLowerCase();
    if (grossesse === 'true')  state.answers.Q1 = ['enceinte'];
    else if (grossesse === 'false') state.answers.Q1 = ['aucune'];

    // Âge (Q4) : lettre A..F du quiz peau Q7_1 mappée vers les 5 tranches
    // du quiz nutrition. A (<18) et B (18-24) sont fusionnés sur '<25'.
    //   A: <18      → <25       D: 35-44    → 35-44
    //   B: 18-24    → <25       E: 45-54    → 45-54
    //   C: 25-34    → 25-34     F: 55+      → 55+
    const age = (params.get('age') || '').toUpperCase();
    const ageMap = { A: '<25', B: '<25', C: '25-34', D: '35-44', E: '45-54', F: '55+' };
    if (ageMap[age]) state.answers.Q4 = ageMap[age];

    if (state.depuisQuizPeau) {
      console.log('[Quiz Nutrition] Pré-rempli depuis quiz peau :', {
        genre: state.answers.Q3, grossesse: state.answers.Q1, age: state.answers.Q4,
      });
    }
  }

  // ============================================================
  // 3. QUESTIONS
  // ============================================================
  // Note : les `id` internes (Q1..Q15) sont conservés pour préserver l'algo
  // de scoring. Seul l'ORDRE d'affichage change pour suivre le parcours
  // PROFIL → SÉCURITÉ → COMPLÉMENTS → OBJECTIF → SIGNAUX → ALIMENTATION →
  // ACTIVITÉ → AFFINAGE → CYCLE/DIGESTION.
  function buildQuestions() {
    return [
      // ===== PARTIE 1 — PROFIL & SÉCURITÉ (positions 0-4) =====
      // Position 0 — PROFIL : genre (id Q3)
      {
        id: 'Q3', type: 'single', noAutoAdvance: true, partie: 1,
        domaine: 'PROFIL',
        title: 'Vous êtes…',
        info: 'Le profil biologique influence directement certains besoins en micronutriments. Cette réponse permet d\'adapter les priorités de votre recommandation.',
        options: [
          { value: 'femme',  label: 'Une femme' },
          { value: 'homme',  label: 'Un homme' },
          { value: 'neutre', label: 'Je préfère ne pas préciser' },
        ],
      },
      // Position 1 — PROFIL : âge (id Q4)
      {
        id: 'Q4', type: 'single', partie: 1,
        domaine: 'PROFIL',
        title: 'Quelle est votre tranche d\'âge ?',
        info: 'Les besoins en micronutriments évoluent avec l\'âge. Cette réponse aide à hiérarchiser les priorités sans poser de diagnostic.',
        options: [
          { value: '<25',   label: 'Moins de 25 ans' },
          { value: '25-34', label: '25–34 ans' },
          { value: '35-44', label: '35–44 ans' },
          { value: '45-54', label: '45–54 ans' },
          { value: '55+',   label: '55 ans et plus' },
        ],
      },
      // Position 2 — SÉCURITÉ : grossesse / projet (id Q1)
      {
        id: 'Q1', type: 'multi', noAutoAdvance: true, partie: 1,
        domaine: 'SÉCURITÉ',
        title: 'L\'une de ces situations vous concerne-t-elle ?',
        info: 'Certaines situations nécessitent des précautions particulières. Les actifs concernés sont automatiquement écartés de votre recommandation.',
        options: [
          { value: 'enceinte', label: 'Oui, je suis enceinte' },
          { value: 'allaite',  label: 'Oui, j\'allaite' },
          { value: 'projet',   label: 'J\'envisage une grossesse dans les 6 mois' },
          { value: 'aucune',   label: 'Aucune de ces situations' },
        ],
        aucunKey: 'aucune',
      },
      // Position 3 — SÉCURITÉ : médicaments (id Q2)
      {
        id: 'Q2', type: 'multi', noAutoAdvance: true, partie: 1,
        domaine: 'SÉCURITÉ',
        title: 'Suivez-vous un traitement médical régulier ?',
        info: 'Certains compléments peuvent interagir avec des médicaments courants. Cette information reste confidentielle et permet d\'adapter votre recommandation.',
        options: [
          { value: 'anticoag', label: 'Anticoagulants (Sintrom, Xarelto, Eliquis…)' },
          { value: 'hta',      label: 'Antihypertenseurs' },
          { value: 'psy',      label: 'Antidépresseurs ou anxiolytiques' },
          { value: 'hormonal', label: 'Traitement hormonal (pilule, THM, progestatifs)' },
          { value: 'thyroide', label: 'Médicaments pour la thyroïde (Levothyrox…)' },
          { value: 'autre',    label: 'Autre traitement régulier' },
          { value: 'aucun',    label: 'Aucun traitement régulier' },
        ],
        aucunKey: 'aucun',
      },
      // Position 4 — COMPLÉMENTS : déjà pris (id Q5)
      {
        id: 'Q5', type: 'chips', partie: 1,
        domaine: 'COMPLÉMENTS',
        title: 'Prenez-vous déjà des compléments alimentaires ?',
        subtitle: 'Pour éviter les doublons.',
        info: 'Les actifs que vous prenez déjà sont dépriorisés dans votre recommandation. L\'objectif est de compléter intelligemment votre routine, pas d\'accumuler.',
        options: [
          { value: 'magnesium',     label: 'Magnésium' },
          { value: 'omega3',        label: 'Oméga-3' },
          { value: 'vitamine_d',    label: 'Vitamine D' },
          { value: 'zinc',          label: 'Zinc' },
          { value: 'fer',           label: 'Fer' },
          { value: 'vitamines_b',   label: 'Vitamines B' },
          { value: 'probiotiques',  label: 'Probiotiques' },
          { value: 'vitamine_c',    label: 'Vitamine C' },
          { value: 'collagene',     label: 'Collagène' },
          { value: 'adaptogenes',   label: 'Adaptogènes' },
          { value: 'hormones_cycle', label: 'Hormones & cycle' },
          { value: 'aucun',         label: 'Aucun pour l\'instant' },
        ],
        aucunKey: 'aucun',
      },
      // Position 4 bis — COMPLÉMENTS : forme galénique préférée (id Q5b) — fin Partie 1
      // N'impacte pas le scoring : sert uniquement à orienter le choix produit
      // côté affichage / catalogue. Stocké dans answers.Q5b (alias forme_galenique).
      {
        id: 'Q5b', type: 'single', partie: 1,
        domaine: 'COMPLÉMENTS',
        title: 'Avez-vous une préférence de format ?',
        subtitle: 'Pour adapter le choix produit quand c\'est possible.',
        info: 'Quand deux formulations existent pour le même actif, cette réponse oriente le choix produit. Elle ne modifie pas les actifs recommandés.',
        options: [
          { value: 'gelules',     label: 'Gélules ou comprimés' },
          { value: 'poudre',      label: 'Poudre ou liquide' },
          { value: 'peu_importe', label: 'Peu importe' },
        ],
      },

      // ===== PARTIE 2 — OBJECTIF & SIGNAUX (positions 5-9) =====
      // Position 5 — OBJECTIF principal (id Q6)
      {
        id: 'Q6', type: 'single', noAutoAdvance: true, partie: 2,
        domaine: 'OBJECTIF',
        title: 'Quel est votre objectif principal ?',
        subtitle: 'Ce qui vous préoccupe le plus en ce moment.',
        info: 'Votre priorité principale oriente toute la construction de votre cure. Choisissez ce qui vous gêne le plus aujourd\'hui.',
        optionsBuilder: (s) => objectifsForGenre(s.answers.Q3),
      },
      // Position 6 — SIGNAUX : réveil (id Q7)
      {
        id: 'Q7', type: 'single', partie: 2,
        domaine: 'SIGNAUX',
        title: 'À quelle heure vous réveillez-vous naturellement ?',
        info: 'Le réveil spontané reflète la qualité de votre récupération et votre rythme veille-sommeil. C\'est un signal utile pour orienter certaines recommandations.',
        options: [
          { value: 'avant_6h', label: 'Avant 6h — et j\'ai du mal à me rendormir' },
          { value: '6h_7h30',  label: 'Entre 6h et 7h30 — naturellement' },
          { value: '7h30_9h',  label: 'Entre 7h30 et 9h — j\'ai besoin de temps' },
          { value: 'apres_9h', label: 'Après 9h ou uniquement avec alarme' },
        ],
      },
      // Position 7 — SIGNAUX : énergie (id Q8)
      {
        id: 'Q8', type: 'single', partie: 2,
        domaine: 'SIGNAUX',
        title: 'Comment se passe votre énergie au fil de la journée ?',
        info: 'Le niveau d\'énergie au fil de la journée est un signal utile pour orienter certaines recommandations, sans poser de diagnostic.',
        options: [
          { value: 'stable',     label: 'Aucune baisse notable' },
          { value: 'legere',     label: 'Légère somnolence, je tiens' },
          { value: 'coup_barre', label: 'Coup de barre marqué — café ou sucre' },
          { value: 'epuisement', label: 'Épuisement réel, difficile de fonctionner' },
        ],
      },
      // Position 8 — ALIMENTATION (id Q9)
      {
        id: 'Q9', type: 'single', partie: 2,
        domaine: 'ALIMENTATION',
        title: 'Comment décririez-vous votre alimentation au quotidien ?',
        subtitle: 'Sans vous juger — pour adapter votre cure.',
        info: 'Votre alimentation influence directement vos apports en micronutriments essentiels. Certains profils alimentaires méritent une attention particulière.',
        options: [
          { value: 'omnivore_eq',  label: 'Omnivore équilibré — légumes et protéines variées' },
          { value: 'omnivore_irr', label: 'Omnivore irrégulier — plats préparés fréquents' },
          { value: 'flexitarien',  label: 'Flexitarien — peu de viande, produits laitiers' },
          { value: 'vegetarien',   label: 'Végétarien — pas de viande ni poisson' },
          { value: 'vegan',        label: 'Végétalien / vegan — aucun produit animal' },
        ],
      },
      // Position 9 — ACTIVITÉ : sport (id Q10) — fin Partie 2
      {
        id: 'Q10', type: 'single', partie: 2,
        domaine: 'ACTIVITÉ',
        title: 'Quelle est votre activité physique hebdomadaire ?',
        info: 'L\'activité physique augmente certains besoins en micronutriments. Votre cure s\'ajuste selon votre niveau d\'effort réel.',
        options: [
          { value: '<2',  label: 'Moins de 2h par semaine' },
          { value: '2-4', label: '2 à 4h — régulier mais modéré' },
          { value: '4-7', label: '4 à 7h — entraînements structurés' },
          { value: '>7',  label: 'Plus de 7h — sport intensif ou compétition' },
        ],
      },

      // ===== PARTIE 3 — AFFINAGE (positions 10-14) =====
      // Position 10 — OBJECTIF secondaire (id Q11)
      {
        id: 'Q11', type: 'single', noAutoAdvance: true, partie: 3,
        domaine: 'OBJECTIF',
        title: 'Avez-vous un second objectif ?',
        subtitle: 'Optionnel — pour affiner votre cure.',
        info: 'Un second objectif permet d\'affiner 1 à 2 actifs de votre cure. La priorité principale reste toujours dominante. Si vous n\'avez pas de second objectif clair, choisissez Aucun.',
        optionsBuilder: (s) => {
          const principal = s.answers.Q6;
          const list = objectifsForGenre(s.answers.Q3).filter(o => o.value !== principal);
          return [{ value: 'aucun', label: 'Aucun second objectif' }].concat(list);
        },
      },
      // Position 11 — SIGNAUX : froid (id Q12)
      {
        id: 'Q12', type: 'single', partie: 3,
        domaine: 'SIGNAUX',
        title: 'Avez-vous souvent froid aux extrémités ?',
        subtitle: 'Même en intérieur, même en été.',
        info: 'Ce signal peut orienter vers certains besoins nutritionnels de fond. Si ce signe est marqué ou récent, un bilan biologique peut être utile avant de démarrer une supplémentation.',
        options: [
          { value: 'rarement',  label: 'Rarement ou jamais' },
          { value: 'parfois',   label: 'Parfois, surtout en hiver' },
          { value: 'souvent',   label: 'Souvent, même en été' },
          { value: 'permanent', label: 'Presque en permanence' },
        ],
      },
      // Position 12 — SIGNAUX : symptômes du quotidien (id Q13)
      // Note : option 'digestion' ajoutée pour préserver le signal digestion
      // chez les profils femme (qui n'auront pas Q15 digestion).
      {
        id: 'Q13', type: 'multi', noAutoAdvance: true, partie: 3,
        domaine: 'SIGNAUX',
        title: 'Parmi ces signes du quotidien, lesquels vous ressemblent ?',
        subtitle: 'Cochez ceux qui vous correspondent.',
        info: 'Ces signaux du quotidien orientent vers des besoins spécifiques en micronutriments. L\'analyse les croise avec l\'ensemble de vos réponses.',
        options: [
          { value: 'tensions',     label: 'Tensions dans la nuque ou les épaules' },
          { value: 'palpitations', label: 'Palpitations ponctuelles' },
          { value: 'irritabilite', label: 'Irritabilité ou impatience inhabituelles' },
          { value: 'envies_sucre', label: 'Envies sucrées intenses en fin d\'après-midi' },
          { value: 'bruxisme',     label: 'Mâchoires serrées ou grincement des dents' },
          { value: 'digestion',    label: 'Ballonnements ou digestion difficile' },
          { value: 'aucun',        label: 'Aucun de ces signes' },
        ],
        aucunKey: 'aucun',
      },
      // Position 13 — SIGNAUX : peau / cheveux / ongles (id Q14)
      {
        id: 'Q14', type: 'single', partie: 3,
        domaine: 'SIGNAUX',
        title: 'Et du côté de votre peau, vos cheveux ou vos ongles ?',
        subtitle: 'Des signaux que l\'on sous-estime souvent.',
        info: 'La peau, les cheveux et les ongles reflètent parfois les apports nutritionnels de fond. Ces signes sont croisés avec vos autres réponses pour affiner la recommandation.',
        options: [
          { value: 'aucun',      label: 'Aucun signe particulier' },
          { value: 'bosses',     label: 'Petites bosses rugueuses sur les bras ou cuisses' },
          { value: 'ongles',     label: 'Ongles striés, cassants ou qui se dédoublent' },
          { value: 'tres_seche', label: 'Peau très sèche malgré une hydratation correcte' },
          { value: 'plusieurs',  label: 'Plusieurs de ces signes à la fois' },
        ],
      },
      // Position 14 — CYCLE (femme) ou DIGESTION (homme/neutre) (id Q15)
      {
        id: 'Q15', type: 'single', partie: 3,
        domaineBuilder: (s) => s.answers.Q3 === 'femme' ? 'CYCLE' : 'DIGESTION',
        titleBuilder: (s) => s.answers.Q3 === 'femme'
          ? 'Comment se passe votre cycle menstruel ?'
          : 'Comment se passe votre digestion après les repas ?',
        infoBuilder: (s) => s.answers.Q3 === 'femme'
          ? 'Le cycle donne des indications utiles sur certains besoins nutritionnels et hormonaux. Ces réponses permettent d\'adapter la cure avec prudence.'
          : 'La qualité digestive influence la tolérance et l\'assimilation des compléments. Ces réponses permettent d\'adapter les priorités de votre cure.',
        optionsBuilder: (s) => s.answers.Q3 === 'femme'
          ? [
              { value: 'cycle_reg',  label: 'Régulier, sans douleur notable' },
              { value: 'cycle_dlr',  label: 'Régulier mais douloureux (crampes, règles abondantes)' },
              { value: 'cycle_irr',  label: 'Irrégulier ou très espacé, hors ménopause' },
              { value: 'menopause',  label: 'Ménopause ou préménopause' },
              { value: 'cycle_skip', label: 'Je préfère ne pas préciser' },
            ]
          : [
              { value: 'dig_ok',     label: 'Aucun problème — digestion fluide' },
              { value: 'dig_legere', label: 'Légère lourdeur ou ballonnements occasionnels' },
              { value: 'dig_freq',   label: 'Ballonnements fréquents ou gaz importants' },
              { value: 'dig_dlr',    label: 'Douleurs, crampes ou transit irrégulier' },
            ],
      },
    ];
  }

  function objectifsForGenre(genre) {
    if (genre === 'femme') return [
      { value: 'energie',          label: 'Énergie & fatigue' },
      { value: 'immunite',         label: 'Immunité' },
      { value: 'sommeil',          label: 'Sommeil' },
      { value: 'hormonal_cycle',   label: 'Équilibre hormonal & cycle' },
      { value: 'peau_phaneres',    label: 'Peau & phanères' },
      { value: 'digestion',        label: 'Digestion & microbiote' },
      { value: 'articulations',    label: 'Articulations & os' },
      { value: 'concentration',    label: 'Concentration & mémoire' },
      { value: 'vitalite_femme',   label: 'Vitalité féminine' },
      { value: 'sport',            label: 'Sport & récupération' },
      { value: 'projet_grossesse', label: 'Projet de grossesse' },
    ];
    if (genre === 'homme') return [
      { value: 'energie',          label: 'Énergie & fatigue' },
      { value: 'immunite',         label: 'Immunité' },
      { value: 'sommeil',          label: 'Sommeil' },
      { value: 'vitalite_homme',   label: 'Vitalité & équilibre hormonal' },
      { value: 'libido',           label: 'Libido & performance' },
      { value: 'digestion',        label: 'Digestion & microbiote' },
      { value: 'articulations',    label: 'Articulations & os' },
      { value: 'concentration',    label: 'Concentration & mémoire' },
      { value: 'sport',            label: 'Sport & récupération' },
      { value: 'fertilite_homme',  label: 'Fertilité masculine' },
    ];
    return [
      { value: 'energie',          label: 'Énergie & fatigue' },
      { value: 'immunite',         label: 'Immunité' },
      { value: 'sommeil',          label: 'Sommeil' },
      { value: 'hormonal_cycle',   label: 'Équilibre hormonal' },
      { value: 'peau_phaneres',    label: 'Peau & phanères' },
      { value: 'digestion',        label: 'Digestion & microbiote' },
      { value: 'articulations',    label: 'Articulations & os' },
      { value: 'concentration',    label: 'Concentration & mémoire' },
      { value: 'vitalite_neutre',  label: 'Vitalité & libido' },
      { value: 'sport',            label: 'Sport & récupération' },
    ];
  }

  // ============================================================
  // 4. HELPER h() — createElement
  // ============================================================
  function h(tag, attrs, children) {
    const el = document.createElement(tag);
    if (attrs) {
      Object.entries(attrs).forEach(([k, v]) => {
        if (v == null || v === false) return;
        if (k === 'html') el.innerHTML = v;
        else if (k === 'class') el.className = v;
        else if (k === 'dataset') Object.assign(el.dataset, v);
        else if (k === 'on') Object.entries(v).forEach(([ev, fn]) => el.addEventListener(ev, fn));
        else if (k === 'style' && typeof v === 'object') Object.assign(el.style, v);
        else el.setAttribute(k, v);
      });
    }
    if (children != null) {
      const list = Array.isArray(children) ? children : [children];
      list.forEach(c => {
        if (c == null || c === false) return;
        if (typeof c === 'string' || typeof c === 'number') el.appendChild(document.createTextNode(c));
        else el.appendChild(c);
      });
    }
    return el;
  }

  // SVG inline (icônes simples)
  function svg(d, viewBox) {
    const ns = 'http://www.w3.org/2000/svg';
    const s = document.createElementNS(ns, 'svg');
    s.setAttribute('viewBox', viewBox || '0 0 24 24');
    s.setAttribute('fill', 'none');
    s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', '1.6');
    s.setAttribute('stroke-linecap', 'round');
    s.setAttribute('stroke-linejoin', 'round');
    const p = document.createElementNS(ns, 'path');
    p.setAttribute('d', d);
    s.appendChild(p);
    return s;
  }
  const ICONS = {
    shield:    'M12 2 4 5v7c0 5 3.5 8.5 8 10 4.5-1.5 8-5 8-10V5l-8-3z',
    pulse:     'M3 12h4l3-9 4 18 3-9h4',
    layers:    'M12 2 2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5',
    check:     'M20 6 9 17l-5-5',
    arrow:     'M5 12h14m-6-6 6 6-6 6',
    info:      'M12 8v4m0 4h.01M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z',
    pharm:     'M9 11V7a3 3 0 0 1 6 0v4M5 11h14v9a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-9z',
    star:      'M12 2 15 9l7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1z',
    lock:      'M5 11h14v10H5zM7 11V7a5 5 0 0 1 10 0v4',
    clock:     'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM12 6v6l4 2',
    tag:       'M20 13.5 13.5 20a2 2 0 0 1-2.8 0L3 12.3V3h9.3L20 10.7a2 2 0 0 1 0 2.8z',
    flash:     'M13 2 3 14h7v8l10-12h-7V2z',
  };

  // ============================================================
  // 5. ALGORITHME DE SCORING
  // ============================================================
  function runScoring(answers, mode) {
    const a = answers;
    const scores = {};
    Object.keys(CATALOGUE).forEach(k => { scores[k] = 0; });
    const add = (key, n) => { if (scores[key] != null) scores[key] += n; };

    // Q7 réveil
    switch (a.Q7) {
      case 'avant_6h': add('magnesium', 4); add('ashwagandha', 3); add('vitamine_b', 2); break;
      case 'apres_9h': add('vitamine_d', 3); add('coq10', 2); break;
    }
    // Q8 énergie
    switch (a.Q8) {
      case 'coup_barre': add('coq10', 4); add('vitamine_b', 3); add('magnesium', 1); break;
      case 'epuisement': add('coq10', 6); add('vitamine_b', 4); add('vitamine_d', 3); break;
    }
    // Q9 alimentation
    switch (a.Q9) {
      case 'vegan':
        add('b12', 7); add('omega3_algue', 6); add('spiruline', 4);
        add('fer_femme', 3); add('zinc', 3); add('vitamine_d', 2); break;
      case 'vegetarien':
        add('b12', 4); add('fer_femme', 3); add('omega3', 4); add('zinc', 2); break;
      case 'omnivore_irr':
        add('vitamine_b', 4); add('omega3', 3); add('vitamine_c', 3);
        add('magnesium', 2); add('probiotiques', 2); break;
    }
    // Q10 sport
    switch (a.Q10) {
      case '>7':  add('magnesium', 5); add('coq10', 4); add('omega3', 3); add('zinc', 2); break;
      case '4-7': add('magnesium', 3); add('coq10', 3); add('omega3', 2); break;
      case '<2':  add('vitamine_d', 2); break;
    }
    // Q4 âge
    if (a.Q4 === '45-54' || a.Q4 === '55+') {
      add('coq10', 4); add('calcium', 4); add('vitamine_d', 3); add('omega3', 2);
    } else if (a.Q4 === '35-44') {
      add('coq10', 2); add('vitamine_d', 1);
    }
    // Q3 genre
    if (a.Q3 === 'femme') add('fer_femme', 2);
    if (a.Q3 === 'homme') {
      add('zinc_selenium', 2);
      if (a.Q4 === '35-44' || a.Q4 === '45-54' || a.Q4 === '55+') add('zinc_selenium', 3);
    }

    // Partie 3 (mode complet)
    if (mode === 'complete') {
      if (a.Q12 === 'souvent' || a.Q12 === 'permanent') {
        add('fer_femme', 4); add('magnesium', 3); add('omega3', 2);
      } else if (a.Q12 === 'parfois') {
        add('fer_femme', 1); add('omega3', 1);
      }
      const symp = Array.isArray(a.Q13) ? a.Q13 : [];
      if (symp.includes('bruxisme')) add('magnesium', 5);
      if (symp.includes('tensions')) add('magnesium', 4);
      if (symp.includes('palpitations')) { add('magnesium', 3); add('coq10', 2); }
      if (symp.includes('irritabilite')) { add('magnesium', 2); add('omega3', 2); }
      if (symp.includes('envies_sucre')) { add('vitamine_b', 4); add('coq10', 3); }
      // Signal digestion via Q13 (préserve le signal pour profil femme qui
      // n'a pas Q15 digestion).
      if (symp.includes('digestion')) { add('probiotiques', 4); add('curcuma', 2); }
      const stressCount = ['tensions','palpitations','irritabilite','bruxisme','envies_sucre']
        .filter(s => symp.includes(s)).length;
      if (stressCount >= 3) add('ashwagandha', 5);
      else if (stressCount >= 2) add('magnesium', 2);
      switch (a.Q14) {
        case 'bosses':     add('vitamine_d', 5); add('omega3', 3); break;
        case 'ongles':     add('zinc', 5); add('collagene', 3); break;
        case 'tres_seche': add('omega3', 5); add('vitamine_d', 3); add('collagene', 2); break;
        case 'plusieurs':  add('zinc', 4); add('omega3', 4); add('vitamine_d', 4); add('collagene', 3); break;
      }
      if (a.Q3 === 'femme') {
        switch (a.Q15) {
          case 'cycle_dlr': add('omega3', 5); add('magnesium', 4); add('vitamine_b', 2); add('fer_femme', 3); break;
          case 'cycle_irr': add('inositol', 6); add('vitex', 5); add('vitamine_b', 3); add('magnesium', 2); break;
          case 'menopause': add('calcium', 5); add('vitamine_d', 4); add('magnesium', 3); add('omega3', 3); break;
        }
      } else {
        switch (a.Q15) {
          case 'dig_legere': add('probiotiques', 3); break;
          case 'dig_freq':   add('probiotiques', 6); add('curcuma', 2); add('omega3', 2); break;
          case 'dig_dlr':    add('probiotiques', 6); add('curcuma', 4); add('omega3', 3); break;
        }
      }
    }

    // Objectifs
    const objMap = {
      energie:          { coq10: 5, vitamine_b: 4, vitamine_d: 2 },
      immunite:         { vitamine_d: 5, vitamine_c: 4, zinc: 4, probiotiques: 3 },
      sommeil:          { magnesium: 5, melatonine: 4, ashwagandha: 2 },
      hormonal_cycle:   { inositol: 5, vitex: 4, vitamine_b: 3, magnesium: 2 },
      peau_phaneres:    { collagene: 5, zinc: 4, omega3: 4, vitamine_c: 3 },
      digestion:        { probiotiques: 6, omega3: 3, curcuma: 3 },
      articulations:    { collagene: 4, curcuma: 4, calcium: 4, vitamine_d: 3 },
      concentration:    { omega3: 5, vitamine_b: 4, coq10: 2 },
      vitalite_femme:   { ashwagandha: 4, magnesium: 3, vitamine_b: 2 },
      sport:            { coq10: 4, magnesium: 4, omega3: 3, zinc: 2 },
      projet_grossesse: { inositol: 6, vitamine_b: 5, coq10: 4, zinc: 3, omega3: 3 },
      vitalite_homme:   { zinc_selenium: 5, ashwagandha: 4, vitamine_d: 2 },
      libido:           { tribulus_maca: 6, zinc_selenium: 5, ashwagandha: 3 },
      fertilite_homme:  { coq10: 5, zinc_selenium: 5, omega3: 4, vitamine_b: 3 },
      vitalite_neutre:  { zinc_selenium: 4, ashwagandha: 4, vitamine_d: 2 },
    };
    const applyObj = (key, mult) => {
      if (!key || !objMap[key]) return;
      Object.entries(objMap[key]).forEach(([actif, pts]) => add(actif, pts * mult));
    };
    applyObj(a.Q6, 1.0);
    if (mode === 'complete' && a.Q11 && a.Q11 !== 'aucun') applyObj(a.Q11, 0.75);

    // Déductions déjà pris
    const dejaPris = Array.isArray(a.Q5) ? a.Q5 : [];
    const dejaMap = {
      magnesium: ['magnesium'], omega3: ['omega3', 'omega3_algue'],
      vitamine_d: ['vitamine_d'], zinc: ['zinc', 'zinc_selenium'],
      fer: ['fer_femme'], vitamines_b: ['vitamine_b', 'b12'],
      probiotiques: ['probiotiques'], vitamine_c: ['vitamine_c'],
      collagene: ['collagene'], adaptogenes: ['ashwagandha'],
      hormones_cycle: ['inositol', 'vitex'],
    };
    const deductionsApplied = new Set();
    dejaPris.forEach(p => {
      const t = dejaMap[p];
      if (!t) return;
      t.forEach(k => { if (scores[k] != null) { scores[k] -= 18; deductionsApplied.add(k); } });
    });

    // Vegan : omega3 marin reste exclu
    if (a.Q9 === 'vegan') scores.omega3 = -999;

    // CI
    const ciBlocked = new Set();
    const Q1 = Array.isArray(a.Q1) ? a.Q1 : [];
    const Q2 = Array.isArray(a.Q2) ? a.Q2 : [];
    const isGrossesse = Q1.includes('enceinte') || Q1.includes('allaite');
    const isProjet = Q1.includes('projet');
    const medAnticoag = Q2.includes('anticoag');
    const medPsy = Q2.includes('psy');
    const medHormonal = Q2.includes('hormonal');
    const medThyroide = Q2.includes('thyroide');
    const medHta = Q2.includes('hta');

    Object.values(CATALOGUE).forEach(actif => {
      if (isGrossesse && actif.ci_grossesse) ciBlocked.add(actif.key);
      if (isProjet && actif.ci_projet_grossesse) ciBlocked.add(actif.key);
      if (medAnticoag && actif.ci_anticoag) ciBlocked.add(actif.key);
      if (medPsy && actif.ci_psy) ciBlocked.add(actif.key);
      if (medHormonal && actif.ci_hormonal) ciBlocked.add(actif.key);
      if (medThyroide && actif.ci_thyroide) ciBlocked.add(actif.key);
      if (medHta && actif.ci_hta) ciBlocked.add(actif.key);
    });
    if (isGrossesse || isProjet) {
      ['ashwagandha', 'tribulus_maca', 'vitex'].forEach(k => ciBlocked.add(k));
    }

    // ──────────────────────────────────────────────────────────────────────
    //  MANDATS VEGAN/VEGETARIEN — sécurité métabolique non-négociable
    //  B12 obligatoire en base pour vegan ET vegetarien (carence
    //  neurologique irréversible chez vegan, déficit fréquent chez
    //  vegetarien).
    //  Oméga-3 algue obligatoire en base pour vegan uniquement (apport
    //  EPA/DHA végétal nécessaire en absence totale de poisson).
    //  Exceptions : si l'utilisateur a déjà déclaré prendre cet actif (Q5)
    //  on respecte le signal ; si une CI active le bloque (peu probable
    //  pour B12/omega3_algue, mais défensif), on saute le mandat.
    // ──────────────────────────────────────────────────────────────────────
    const isVegan = a.Q9 === 'vegan';
    const isVegetarien = a.Q9 === 'vegetarien';
    const takesB = dejaPris.indexOf('vitamines_b') !== -1;
    const takesOmega = dejaPris.indexOf('omega3') !== -1;
    const mandatoryBase = [];
    if ((isVegan || isVegetarien) && !takesB && !ciBlocked.has('b12')) {
      mandatoryBase.push('b12');
    }
    if (isVegan && !takesOmega && !ciBlocked.has('omega3_algue')) {
      mandatoryBase.push('omega3_algue');
    }

    // Sélection finale
    const candidats = Object.entries(scores)
      .filter(([k]) => !ciBlocked.has(k) && k !== 'fer_femme')
      .map(([k, s]) => ({ key: k, score: s }))
      .sort((x, y) => y.score - x.score);
    const positifs = candidats.filter(c => c.score > 0);
    // Build directs : mandatoryBase first (sécurité métabolique), then
    // top-scoring others not already mandated.
    const otherDirects = positifs
      .map(c => c.key)
      .filter(k => mandatoryBase.indexOf(k) === -1);
    const directs = mandatoryBase.concat(otherDirects).slice(0, 4);

    const ferScore = scores.fer_femme || 0;
    const ferCI = ciBlocked.has('fer_femme');
    const isFemme = a.Q3 === 'femme';
    const froidFort = a.Q12 === 'souvent' || a.Q12 === 'permanent';
    const cycleDlr = a.Q15 === 'cycle_dlr';
    const isVegOuVegan = a.Q9 === 'vegetarien' || a.Q9 === 'vegan';
    const ferConditionnel = (ferScore > 0 && !ferCI && isFemme &&
      (froidFort || cycleDlr || isVegOuVegan));

    let baseEssentielle, ciblage, conditionnels;
    if (mode === 'partial') {
      baseEssentielle = directs.slice(0, 2);
      ciblage = directs.slice(2, 3);
      conditionnels = [];
    } else {
      baseEssentielle = directs.slice(0, 2);
      ciblage = directs.slice(2, 4);
      conditionnels = ferConditionnel ? ['fer_femme'] : [];
    }

    return {
      mode, scores,
      ci: Array.from(ciBlocked),
      deductions: Array.from(deductionsApplied),
      directs, baseEssentielle, ciblage, conditionnels, ferConditionnel,
      objectifLabel: OBJECTIF_LABELS[a.Q6] || 'Personnalisé',
      profil: {
        genre: a.Q3, age: a.Q4,
        objectif: a.Q6, objectifSecondaire: a.Q11 || null,
        alimentation: a.Q9, sport: a.Q10,
        grossesse: isGrossesse, projetGrossesse: isProjet,
      },
    };
  }

  // ============================================================
  // 5b. COMPUTE ADDONS — sélection 2 actifs max selon synergies / saisonnier
  // ============================================================
  // Règles :
  // 1. Synergies non prescrites en priorité (mg+B, collagène+C, omega3+probio, coq10+omega3)
  // 2. Fallback contexte saisonnier (vit D auto, spiruline si sport intensif)
  // Ne jamais proposer un actif déjà dans dejapris ni déjà dans la cure principale.
  function computeAddons(result, answers) {
    const inCure = new Set([...result.baseEssentielle, ...result.ciblage, ...result.conditionnels]);
    const dejapris = Array.isArray(answers.Q5) ? answers.Q5 : [];
    const dejaMap = {
      magnesium: ['magnesium'], omega3: ['omega3', 'omega3_algue'],
      vitamine_d: ['vitamine_d'], zinc: ['zinc', 'zinc_selenium'],
      fer: ['fer_femme'], vitamines_b: ['vitamine_b', 'b12'],
      probiotiques: ['probiotiques'], vitamine_c: ['vitamine_c'],
      collagene: ['collagene'], adaptogenes: ['ashwagandha'],
      hormones_cycle: ['inositol', 'vitex'],
    };
    const dejaPrisActifs = new Set();
    dejapris.forEach(p => (dejaMap[p] || []).forEach(k => dejaPrisActifs.add(k)));

    function canAdd(key) {
      return !inCure.has(key) && !dejaPrisActifs.has(key);
    }

    const addons = [];
    function pushAddon(key, justification, type) {
      if (addons.length >= 2) return;
      if (!canAdd(key)) return;
      if (addons.find(a => a.key === key)) return;
      addons.push({ key, justification, type });
    }

    // ----- Priorité 1 : synergies non prescrites -----
    if (inCure.has('magnesium'))  pushAddon('vitamine_b', 'Potentialise votre magnésium', 'synergie');
    if (inCure.has('collagene'))  pushAddon('vitamine_c', 'Cofacteur indispensable de votre collagène', 'synergie');
    if (inCure.has('omega3') || inCure.has('omega3_algue'))
                                  pushAddon('probiotiques', 'Renforce l\'axe intestin-inflammation', 'synergie');
    if (inCure.has('coq10')) {
      // Symétrie de la logique vegan : la sélection principale exclut omega3
      // marin pour les vegans (score forcé à -999), donc l'add-on synergie
      // doit utiliser omega3_algue sur ce profil pour rester cohérent.
      const omegaKey = answers.Q9 === 'vegan' ? 'omega3_algue' : 'omega3';
      pushAddon(omegaKey, 'Synergie mitochondriale documentée', 'synergie');
    }

    // ----- Priorité 2 : contexte saisonnier (fallback) -----
    if (addons.length < 2)        pushAddon('vitamine_d', 'Recommandé en automne-hiver', 'saisonnier');
    if (addons.length < 2 && answers.Q10 === '>7')
                                  pushAddon('spiruline', 'Soutien énergie pour les sportifs', 'saisonnier');

    return addons;
  }

  // ============================================================
  // 5c. BUILD BILAN RESULT JSON (pour sessionStorage page résultats)
  // ============================================================
  function buildBilanResult(mode) {
    const result = state._result || runScoring(state.answers, mode === 'complete' ? 'complete' : 'partial');
    const addons = computeAddons(result, state.answers);
    return {
      objectif_principal:  OBJECTIF_LABELS[state.answers.Q6] || result.objectifLabel || 'Personnalisé',
      objectif_secondaire: state.answers.Q11 && state.answers.Q11 !== 'aucun'
                            ? (OBJECTIF_LABELS[state.answers.Q11] || state.answers.Q11)
                            : null,
      genre: state.answers.Q3 || null,
      age:   state.answers.Q4 || null,
      actifs_base:         result.baseEssentielle || [],
      actifs_cible:        result.ciblage || [],
      actifs_conditionnel: result.conditionnels || [],
      actifs_addon:        addons,
      ci_detectees:        result.ci || [],
      dejapris:            state.answers.Q5 || [],
      depuis_quiz_peau:    state.depuisQuizPeau === true,
      forme_galenique:     state.answers.Q5b || null,
      score_personnalisation: mode === 'complete' ? 'complet' : 'partiel',
      _generated_at:       Date.now(),
      // Lu par la page résultats pour l'e-mail « Votre cure » (et le prénom de la notice)
      _meta: { email: state.email || null, firstName: state.firstName || null },
    };
  }

  function redirectToResults(mode) {
    const payload = buildBilanResult(mode);
    try { sessionStorage.setItem(SS_BILAN_KEY, JSON.stringify(payload)); }
    catch (e) { console.error('[Quiz Nutrition] sessionStorage write failed :', e); }
    // Push Klaviyo avant redirection (fire-and-forget)
    try { pushToKlaviyo(); } catch (_) {}
    window.location.href = RESULTATS_PAGE_URL;
  }

  // ============================================================
  // 6. SET BG DARK + ROOT CLASSES — body & data-quiz-root class management
  // ============================================================
  function setBgDark(dark) {
    if (dark) document.body.classList.add('pd-quiz-active', 'pdn-quiz-active');
    else document.body.classList.remove('pd-quiz-active', 'pdn-quiz-active');
  }

  // Le quiz peau scope ses styles via [data-quiz-root].pd-step-sas, .pd-step6, etc.
  // Les classes doivent être appliquées DIRECTEMENT sur l'élément data-quiz-root,
  // pas sur un wrapper interne. On gère ça ici à chaque render().
  function setRootClass(cls) {
    if (!app || !app.root) return;
    // Retirer toutes les classes pd-step-* précédentes
    const toRemove = [];
    app.root.classList.forEach(c => {
      if (c.indexOf('pd-step') === 0 || c === 'pd-fade') toRemove.push(c);
    });
    toRemove.forEach(c => app.root.classList.remove(c));
    if (cls) app.root.classList.add(cls);
  }

  // ============================================================
  // 7. RENDER : SAS WELCOME — pd-welcome
  // ============================================================
  function renderSas() {
    setBgDark(true);
    setRootClass('pd-step-sas');
    const inner = h('div', { class: 'pd-welcome' });

    // V3.34e — logo transparent HD (via Liquid asset_url → window.PARADERMIA_LOGO_URL).
    // Fallback silencieux : l'eyebrow de marque ci-dessous suffit si l'URL manque.
    const logoUrl = window.PARADERMIA_LOGO_URL || null;
    if (logoUrl) {
      const logoWrap = h('a', { class: 'pdn-welcome-logo', href: '/', 'aria-label': 'Accueil ParaDermia' });
      const logoImg = h('img', { class: 'pdn-welcome-logo-img', alt: 'Paradermia' });
      logoImg.src = logoUrl;
      logoWrap.appendChild(logoImg);
      inner.appendChild(logoWrap);
    }

    // V3.34e-2 — Badges réassurance en haut (calqué sur renderStep0 du quiz peau).
    const chipsWrap = h('div', { class: 'pd-welcome-chips' });
    const addChip = (icon, text) => {
      const chip = h('span', { class: 'pd-welcome-chip' });
      const ic = h('span', { class: 'pd-welcome-chip-icon' });
      ic.appendChild(svg(icon));
      chip.appendChild(ic);
      chip.appendChild(document.createTextNode(text));
      chipsWrap.appendChild(chip);
    };
    addChip(ICONS.clock, '2 à 5 min');
    // Badge preuve sociale : nombre RÉEL de bilans sur 30 j (réglage section,
    // alimenté depuis Klaviyo). Affiché seulement au-dessus d'un seuil pour ne
    // jamais montrer un chiffre faible/non probant ; sinon fallback « 100% gratuit ».
    const count30 = window.PARADERMIA_NUTRITION_QUIZ_COUNT_30D;
    const countMin = typeof window.PARADERMIA_NUTRITION_QUIZ_COUNT_MIN === 'number'
      ? window.PARADERMIA_NUTRITION_QUIZ_COUNT_MIN : 30;
    if (typeof count30 === 'number' && count30 >= countMin) {
      addChip(ICONS.star, count30.toLocaleString('fr-FR') + ' bilans · 30 j');
    } else {
      addChip(ICONS.tag, 'Conseil de pharmacienne');
    }
    inner.appendChild(chipsWrap);

    inner.appendChild(h('div', { class: 'pd-welcome-eyebrow' }, 'Avant de commencer'));
    inner.appendChild(h('h1', {
      class: 'pd-welcome-title',
      html: 'Trouvons <em>votre cure.</em>',
    }));

    // « Pour bien répondre » — 2 lignes (calqué sur le quiz peau)
    const tipsBlock = h('div', { class: 'pd-welcome-tips' });
    tipsBlock.appendChild(h('span', { class: 'pd-welcome-tips-label' }, 'POUR BIEN RÉPONDRE'));
    const tip1 = h('div', { class: 'pd-welcome-tip' });
    tip1.appendChild(h('span', { class: 'pd-welcome-tip-dash' }, '—'));
    tip1.appendChild(document.createTextNode('Répondez selon vos habitudes réelles.'));
    tipsBlock.appendChild(tip1);
    const tip2 = h('div', { class: 'pd-welcome-tip' });
    tip2.appendChild(h('span', { class: 'pd-welcome-tip-dash' }, '—'));
    tip2.appendChild(document.createTextNode('Si vous hésitez, appuyez sur '));
    const tip2Icon = h('span', { class: 'pd-welcome-tip-iicon' });
    tip2Icon.appendChild(svg(ICONS.info));
    tip2.appendChild(tip2Icon);
    tipsBlock.appendChild(tip2);
    inner.appendChild(tipsBlock);

    // Phrase pivot réassurance (calqué sur le quiz peau)
    const pivot = h('div', { class: 'pd-welcome-pivot' });
    pivot.appendChild(h('div', {}, 'Prenez le temps de répondre,'));
    pivot.appendChild(h('div', {}, "votre bilan n'en sera que plus juste."));
    inner.appendChild(pivot);

    // CTA — V3.34e : 2 boutons-cartes (Bilan complet / Bilan rapide). Le choix
    // écrit state.intro_choice, lu par renderBifurcation pour hiérarchiser les
    // 2 CTAs du gate mi-parcours. Le tracking « Bilan Nutrition Démarré » est
    // enrichi du mode choisi. Les deux modes démarrent le même parcours questions ;
    // intro_choice ne fait que pré-orienter la suite au gate (rétrocompat assurée).
    const startQuizWithMode = (mode) => {
      try {
        window._learnq = window._learnq || [];
        window._learnq.push(['track', 'Bilan Nutrition Démarré', {
          source: 'bilan_nutrition',
          started_at: new Date().toISOString(),
          mode: mode,
        }]);
      } catch (err) { /* silent */ }
      state.intro_choice = mode; // 'rapide' | 'complet'
      state.mode = 'questions';
      state.cursor = 0;
      render();
    };

    const buildIntroCta = (variant, label, time, desc, mode) => {
      const btn = h('button', {
        class: 'pdn-intro-cta pdn-intro-cta--' + variant,
        type: 'button',
        dataset: { mode: mode },
        on: { click: () => startQuizWithMode(mode) },
      });
      const topRow = h('div', { class: 'pdn-intro-cta-top' });
      topRow.appendChild(h('span', { class: 'pdn-intro-cta-label' }, label));
      topRow.appendChild(h('span', { class: 'pdn-intro-cta-time' }, time));
      btn.appendChild(topRow);
      btn.appendChild(h('span', { class: 'pdn-intro-cta-desc' }, desc));
      return btn;
    };

    const ctaWrap = h('div', { class: 'pdn-intro-cta-wrap' });
    ctaWrap.appendChild(buildIntroCta(
      'primary', 'Bilan complet', '5 MIN',
      'Cure affinée selon vos signaux, vos habitudes et vos objectifs.',
      'complet'
    ));
    ctaWrap.appendChild(buildIntroCta(
      'ghost', 'Bilan rapide', '2 MIN',
      'Cure essentielle adaptée à votre profil, si vous êtes pressé(e).',
      'rapide'
    ));
    inner.appendChild(ctaWrap);

    // Réassurance en bas (calqué sur le quiz peau — trust-v2 3 items, credential inclus)
    const trust = h('div', { class: 'pd-welcome-trust pd-welcome-trust-v2' });
    [
      { icon: ICONS.pharm, text: 'Docteure en pharmacie' },
      { icon: ICONS.lock,  text: 'Confidentiel' },
      { icon: ICONS.flash, text: 'Résultat immédiat' },
    ].forEach((t, i) => {
      const item = h('span', { class: 'pd-welcome-trust-item' });
      const icoT = h('span', { class: 'pd-welcome-trust-icon' });
      icoT.appendChild(svg(t.icon));
      item.appendChild(icoT);
      item.appendChild(document.createTextNode(' ' + t.text));
      trust.appendChild(item);
      if (i < 2) trust.appendChild(h('span', { class: 'pd-welcome-trust-sep' }));
    });
    inner.appendChild(trust);

    return inner;
  }

  // ============================================================
  // 8. RENDER : QUESTIONS — pd-question
  // ============================================================
  function renderQuestionView() {
    setBgDark(true);
    setRootClass(null);
    const q = getCurrentQuestion();
    const options = questionVisibleOptions(q);
    const domaine = q.domaineBuilder ? q.domaineBuilder(state) : q.domaine;
    const infoText = q.infoBuilder ? q.infoBuilder(state) : q.info;

    const wrapper = h('div', { class: 'pd-question-wrapper' });

    // Progression bar
    const prog = h('div', { class: 'pd-progression' });
    const fill = h('div', { class: 'pd-progression__fill is-visible' });
    fill.appendChild(document.createTextNode('​'));
    fill.style.width = computeProgressPct() + '%';
    prog.appendChild(fill);
    wrapper.appendChild(prog);

    // Domaine au-dessus de la card (en or, uppercase)
    if (domaine) {
      const totalQs = state.parcours === 'complet' ? PARTIE_3_END + 1 : PARTIE_2_END + 1;
      const eyebrow = h('div', { class: 'pdn-question-domaine' });
      eyebrow.appendChild(h('span', { class: 'pdn-question-domaine-label' }, domaine));
      eyebrow.appendChild(h('span', { class: 'pdn-question-domaine-sep' }, '·'));
      eyebrow.appendChild(h('span', { class: 'pdn-question-domaine-count' },
        (state.cursor + 1) + '/' + totalQs));
      wrapper.appendChild(eyebrow);
    }

    const card = h('div', { class: 'pd-question pd-fade' });

    // Bouton info en haut à droite avec tooltip popover (pas de modale full-screen)
    if (infoText) {
      const infoWrap = h('div', { class: 'pdn-info-wrap' });
      const infoBtn = h('button', {
        class: 'pdn-question-info-btn',
        type: 'button',
        'aria-label': 'Pourquoi cette question ?',
        'aria-expanded': 'false',
        on: {
          click: (e) => {
            e.stopPropagation();
            const open = infoWrap.classList.toggle('is-open');
            infoBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
          },
        },
      }, 'i');
      const tooltip = h('div', { class: 'pdn-info-tooltip', role: 'tooltip' });
      tooltip.appendChild(h('div', { class: 'pdn-info-tooltip-eyebrow' }, 'POURQUOI'));
      tooltip.appendChild(h('p', { class: 'pdn-info-tooltip-text' }, infoText));
      infoWrap.appendChild(infoBtn);
      infoWrap.appendChild(tooltip);
      card.appendChild(infoWrap);
    }

    // Title
    const title = q.titleBuilder ? q.titleBuilder(state) : q.title;
    card.appendChild(h('h2', { class: 'pd-question-title' }, title));

    // Subtitle (court, optionnel)
    const subtitle = q.subtitleBuilder ? q.subtitleBuilder(state) : q.subtitle;
    if (subtitle) card.appendChild(h('p', { class: 'pdn-question-subtitle' }, subtitle));

    // Options
    if (q.type === 'chips') {
      card.appendChild(renderChips(q, options));
    } else {
      card.appendChild(renderOptions(q, options));
    }

    // Footer
    card.appendChild(renderQuestionFooter(q));

    wrapper.appendChild(card);

    return wrapper;
  }

  // ---------- Tooltip info popover : fermeture au clic ailleurs / Escape ----------
  if (typeof window !== 'undefined' && !window._pdnInfoListenersAdded) {
    document.addEventListener('click', (e) => {
      document.querySelectorAll('.pdn-info-wrap.is-open').forEach(w => {
        if (!w.contains(e.target)) {
          w.classList.remove('is-open');
          const btn = w.querySelector('.pdn-question-info-btn');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        document.querySelectorAll('.pdn-info-wrap.is-open').forEach(w => {
          w.classList.remove('is-open');
          const btn = w.querySelector('.pdn-question-info-btn');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });
      }
    });
    window._pdnInfoListenersAdded = true;
  }

  function renderOptions(q, options) {
    const wrap = h('div', {
      class: 'pd-options ' + (q.type === 'multi' ? 'pd-options-multi' : 'pd-options-single'),
    });
    const current = state.answers[q.id];
    options.forEach(opt => {
      const isSelected = q.type === 'multi'
        ? Array.isArray(current) && current.includes(opt.value)
        : current === opt.value;
      const btn = h('button', {
        class: 'pd-option' + (isSelected ? ' is-selected' : ''),
        type: 'button',
        'data-value': opt.value,
        on: { click: () => onSelect(q, opt.value) },
      });
      const body = h('div', { class: 'pd-option-body' });
      body.appendChild(h('span', { class: 'pd-option-bullet' }));
      body.appendChild(h('span', { class: 'pd-option-label' }, opt.label));
      btn.appendChild(body);
      wrap.appendChild(btn);
    });
    return wrap;
  }

  function renderChips(q, options) {
    const wrap = h('div', { class: 'pdn-chips' });
    const current = state.answers[q.id] || [];
    options.forEach(opt => {
      const isSelected = current.includes(opt.value);
      wrap.appendChild(h('button', {
        class: 'pdn-chip' + (isSelected ? ' is-selected' : ''),
        type: 'button',
        'data-value': opt.value,
        on: { click: () => onSelect(q, opt.value) },
      }, opt.label));
    });
    return wrap;
  }

  function renderQuestionFooter(q) {
    const wrap = h('div', { class: 'pd-footer' });
    if (state.cursor > 0) {
      const back = h('button', {
        class: 'pd-btn pd-btn-ghost',
        type: 'button',
        'data-action': 'back',
        on: { click: goPrev },
      }, '← Précédent');
      wrap.appendChild(back);
    } else {
      wrap.appendChild(h('span', null, ''));
    }

    if (q.type === 'single' && !q.noAutoAdvance) {
      wrap.appendChild(h('span', { class: 'pd-footer-note' }, 'Sélection unique — avancement automatique'));
    } else {
      const valid = isAnswerValid(q);
      const next = h('button', {
        class: 'pd-btn pd-btn-primary',
        type: 'button',
        disabled: !valid ? '' : null,
        on: { click: goNext },
      }, isLastQuestionOfPart2() ? 'Continuer →' : 'Suivant →');
      if (!valid) next.style.opacity = '0.4';
      wrap.appendChild(next);
    }
    return wrap;
  }

  function getQuestions() {
    return state._questionsCache || (state._questionsCache = buildQuestions());
  }
  function getCurrentQuestion() {
    return getQuestions()[state.cursor];
  }
  function questionVisibleOptions(q) {
    return q.optionsBuilder ? q.optionsBuilder(state) : (q.options || []);
  }
  function isAnswerValid(q) {
    const v = state.answers[q.id];
    if (q.type === 'single') return v != null && v !== '';
    if (q.type === 'multi' || q.type === 'chips') return Array.isArray(v) && v.length > 0;
    return false;
  }
  function isLastQuestionOfPart2() {
    return state.cursor === PARTIE_2_END;
  }
  function computeProgressPct() {
    const total = state.parcours === 'complet' ? PARTIE_3_END + 1 : PARTIE_2_END + 1;
    return Math.round(((state.cursor + 1) / total) * 100);
  }

  // ============================================================
  // 9. RENDER : EMAIL CAPTURE — pd-email-capture
  // ============================================================
  function renderEmailCapture() {
    setBgDark(true);
    setRootClass(null);
    const wrap = h('div', { class: 'pd-question pd-email-capture pd-fade' });
    wrap.appendChild(h('div', { class: 'pd-progress-label' }, 'ÉTAPE INTERMÉDIAIRE'));
    wrap.appendChild(h('h2', { class: 'pd-question-title' }, 'Recevez votre protocole par email'));
    wrap.appendChild(h('p', { class: 'pd-question-prompt' },
      'Recevez votre cure par e-mail : les compléments choisis pour vous, quand les prendre, combien de temps, et les précautions.'));

    const form = h('form', {
      class: 'pd-form',
      on: {
        submit: (e) => {
          e.preventDefault();
          submitEmailCapture();
        },
      },
    });
    form.appendChild(h('input', {
      type: 'text', name: 'first_name', class: 'pd-input',
      placeholder: 'Prénom (facultatif)',
      value: state.firstName || '',
      on: { input: (e) => { state.firstName = e.target.value; } },
    }));
    form.appendChild(h('input', {
      type: 'email', name: 'email', class: 'pd-input',
      placeholder: 'votre@email.com',
      value: state.email || '',
      required: 'required',
      on: { input: (e) => { state.email = e.target.value; } },
    }));
    form.appendChild(pdCercleBox());
    form.appendChild(h('button', {
      class: 'pd-btn pd-btn-dark', type: 'submit',
    }, 'Continuer →'));
    wrap.appendChild(form);

    // Skip link discret
    const skip = h('button', {
      class: 'pd-btn pd-btn-ghost',
      type: 'button',
      style: { display: 'block', margin: '12px auto 0', fontSize: '13px' },
      on: { click: () => { state.mode = 'loading1'; render(); } },
    }, 'Passer cette étape');
    wrap.appendChild(skip);

    return wrap;
  }

  function submitEmailCapture() {
    const email = (state.email || '').trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showToast('Email invalide.');
      return;
    }
    state.email = email;
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', { $email: state.email, $first_name: state.firstName || undefined }]);
      window._learnq.push(['track', 'Bilan Nutrition Email Renseigné', { source: 'bilan_nutrition' }]);
      state.cercle = pdCercleSubscribe(document.querySelector('.pd-email-capture form'), state.email, state.firstName, 'Bilan nutrition');
    } catch (err) { /* silent */ }
    state.mode = 'loading1';
    render();
  }

  // ============================================================
  // 10. RENDER : LOADING CHECKLIST — pd-transition-1
  // ============================================================
  function renderLoading(items, finalTitle, finalCta, onCta, withPharmacienne) {
    setBgDark(true);
    setRootClass('pd-step-sas');
    const wrap = h('div', { class: 'pd-question pd-transition-1 pd-fade' });

    const eyebrow = h('p', { class: 'pd-transition-eyebrow' }, 'ANALYSE EN COURS');
    wrap.appendChild(eyebrow);

    const steps = h('div', { class: 'pd-transition-steps' });
    const lineEls = [];
    const statusEls = [];
    items.forEach(text => {
      const line = h('div', { class: 'pd-transition-line' });
      line.appendChild(h('p', { class: 'pd-transition-title' }, text));
      const status = h('div', { class: 'pd-transition-status' }, '✓');
      line.appendChild(status);
      steps.appendChild(line);
      lineEls.push(line);
      statusEls.push(status);
    });
    wrap.appendChild(steps);

    const title = h('h2', {
      class: 'pd-transition-1-title',
      html: finalTitle,
    });
    wrap.appendChild(title);

    const cta = h('button', {
      class: 'pd-btn pd-btn-primary pd-transition-1-cta',
      type: 'button',
      on: { click: onCta },
    }, finalCta);
    wrap.appendChild(cta);

    if (withPharmacienne) {
      const pharma = h('div', { class: 'pdn-pharmacienne' });
      pharma.appendChild(document.createTextNode('PROTOCOLE VALIDÉ PAR NOTRE '));
      pharma.appendChild(h('strong', null, 'PHARMACIENNE'));
      wrap.appendChild(pharma);
    }

    // Animation cascade
    const stepDelay = 600;
    lineEls.forEach((line, i) => {
      setTimeout(() => {
        line.classList.add('is-visible');
        statusEls[i].classList.add('is-visible');
      }, stepDelay * (i + 1));
    });
    const totalSteps = items.length;
    setTimeout(() => {
      eyebrow.textContent = 'ANALYSE TERMINÉE';
      eyebrow.classList.add('is-done');
    }, stepDelay * totalSteps + 200);
    setTimeout(() => {
      title.classList.add('is-visible');
    }, stepDelay * totalSteps + 600);
    setTimeout(() => {
      cta.classList.add('is-visible');
      if (withPharmacienne) {
        wrap.querySelector('.pdn-pharmacienne').classList.add('is-visible');
      }
    }, stepDelay * totalSteps + 1100);

    return wrap;
  }

  function renderLoading1() {
    return renderLoading(
      [
        'Vos réponses sont enregistrées.',
        'Votre profil nutritionnel est identifié.',
        'Les contre-indications sont vérifiées.',
      ],
      'Votre profil est <em>analysé.</em>',
      'Découvrir mon protocole →',
      () => { state.mode = 'reveal'; render(); window.scrollTo({ top: 0, behavior: 'smooth' }); },
      false
    );
  }

  function renderLoading2() {
    // Transition finale commune aux 2 parcours. Items adaptés selon
    // parcours partiel (3 items) ou complet (5 items). Mode passé à
    // redirectToResults dépend de state.parcours.
    const isComplet = state.parcours === 'complet';
    const items = isComplet ? [
      'Vos objectifs sont hiérarchisés.',
      'Les signaux physiologiques sont analysés.',
      'Les interactions sont vérifiées.',
      'Les synergies sont identifiées.',
      'Votre protocole complet est prêt.',
    ] : [
      'Votre profil est consolidé.',
      'Les interactions sont vérifiées.',
      'Votre protocole de base est prêt.',
    ];
    return renderLoading(
      items,
      'Votre corps a <em>parlé.</em>',
      'Voir mon protocole →',
      () => redirectToResults(isComplet ? 'complete' : 'partial'),
      true
    );
  }

  // ============================================================
  // 11a. RENDER : REVEAL PROTOCOLE — annonce uniquement, sans produits
  //      Calque exactement le pattern pd-pack-and-tier du quiz peau
  //      mais sans la sélection de tier (juste l'annonce du protocole).
  // ============================================================
  function renderReveal() {
    setBgDark(true);
    setRootClass(null);
    // Calcul du résultat partiel (pour avoir l'objectifLabel) mais on ne
    // rend AUCUN produit ici — juste l'annonce.
    const result = runScoring(state.answers, 'partial');
    state._result = result;
    console.log('[Quiz Nutrition] Reveal protocole :', result.objectifLabel);

    const wrap = h('div', { class: 'pd-question pd-pack-and-tier pd-fade' });

    const section = h('section', { class: 'pd-pat-section pd-pat-section-reveal' });
    section.appendChild(h('p', { class: 'pd-pat-eyebrow' }, 'VOTRE PROTOCOLE DE BASE'));

    const grad = h('div', { class: 'pd-step4-gradient-wrap pdn-pack-reveal' });
    const inner = h('div', { class: 'pd-step4-inner' });
    inner.appendChild(h('div', { class: 'pd-step4-eyebrow' }, 'Votre protocole de base'));
    const title = h('h3', { class: 'pd-step4-routine-name' });
    title.appendChild(document.createTextNode('Protocole '));
    const em = document.createElement('em');
    em.textContent = result.objectifLabel;
    title.appendChild(em);
    inner.appendChild(title);
    inner.appendChild(h('p', { class: 'pd-step4-routine-sub' }, revealSubtitle(result)));
    grad.appendChild(inner);
    section.appendChild(grad);
    wrap.appendChild(section);

    // Phrase unique sous la card
    const note = h('p', {
      style: {
        textAlign: 'center', fontSize: '14px', color: '#7A4A0A',
        margin: '20px auto 24px', maxWidth: '480px', fontStyle: 'italic',
      },
    }, '3 questions supplémentaires permettent d\'affiner cette sélection.');
    wrap.appendChild(note);

    // Footer avec CTA seul
    const footer = h('div', { class: 'pd-footer', style: { justifyContent: 'center' } });
    footer.appendChild(h('button', {
      class: 'pd-btn pd-btn-primary',
      type: 'button',
      on: { click: () => { state.mode = 'bifurcation'; render(); window.scrollTo({ top: 0, behavior: 'smooth' }); } },
    }, 'Continuer →'));
    wrap.appendChild(footer);

    return wrap;
  }

  function revealSubtitle(result) {
    const profil = result.profil;
    const objectif = result.objectifLabel;
    if (objectif === 'Énergie')      return 'Pour retrouver une énergie stable et durable.';
    if (objectif === 'Sommeil')      return 'Pour un sommeil profond et réparateur.';
    if (objectif === 'Immunité')     return 'Pour renforcer vos défenses naturelles.';
    if (objectif === 'Digestion')    return 'Pour rééquilibrer votre microbiote.';
    if (objectif === 'Articulations')return 'Pour soutenir mobilité et minéralisation osseuse.';
    if (objectif === 'Concentration')return 'Pour soutenir mémoire et clarté mentale.';
    if (objectif === 'Sport & Récupération') return 'Pour optimiser performance et récupération.';
    if (objectif === 'Équilibre hormonal' || objectif === 'Équilibre hormonal & cycle') return 'Pour retrouver un équilibre hormonal harmonieux.';
    if (objectif === 'Peau & Phanères') return 'Pour nourrir peau, ongles et cheveux de l\'intérieur.';
    if (objectif === 'Vitalité féminine' || objectif === 'Vitalité masculine' || objectif === 'Vitalité & Libido') return 'Pour retrouver tonus et vitalité au quotidien.';
    if (objectif === 'Libido & Performance') return 'Pour soutenir libido et performance.';
    if (objectif === 'Fertilité masculine') return 'Pour soutenir la fertilité masculine.';
    if (objectif === 'Projet Grossesse') return 'Pour préparer un projet de grossesse en sérénité.';
    return 'Personnalisé selon vos signaux biologiques.';
  }

  // ============================================================
  // 11. RENDER : RÉSULTATS PARTIELS — carte crème (avec produits)
  // ============================================================
  function renderResultsPartial() {
    setBgDark(true);  // garde fond vert avec carte crème centrale
    setRootClass(null);
    const result = runScoring(state.answers, 'partial');
    state._result = result;
    console.log('[Quiz Nutrition] Résultats partiels :', result);

    const wrap = h('div', { class: 'pd-question pd-fade' });

    // Hero
    const hero = h('div', { class: 'pdn-results-hero' });
    hero.appendChild(h('div', { class: 'pdn-results-hero-eyebrow' }, 'VOTRE PROTOCOLE DE BASE'));
    const heroTitle = h('h1', { class: 'pdn-results-hero-title' });
    heroTitle.appendChild(document.createTextNode('Protocole '));
    const em = document.createElement('em');
    em.textContent = result.objectifLabel;
    heroTitle.appendChild(em);
    hero.appendChild(heroTitle);
    wrap.appendChild(hero);

    // Notice or
    wrap.appendChild(h('div', { class: 'pdn-notice pdn-notice-or' },
      '3 questions supplémentaires permettent d\'affiner cette sélection.'));

    if (state.answers.Q3 === 'femme') {
      wrap.appendChild(h('div', { class: 'pdn-notice pdn-notice-vert' },
        'Votre cycle peut modifier 1 à 2 actifs de cette sélection.'));
    }

    if (state.answers.Q6 === 'sport') {
      wrap.appendChild(h('div', { class: 'pdn-notice pdn-notice-warn' },
        'Si votre objectif est la prise de masse musculaire, les compléments de micronutrition n\'agissent pas directement sur cet axe — créatine et protéines relèvent d\'un autre registre.'));
    }

    // Base essentielle
    if (result.baseEssentielle.length > 0) {
      wrap.appendChild(h('h3', { class: 'pdn-results-section-title' }, 'Base essentielle'));
      result.baseEssentielle.forEach(k => wrap.appendChild(renderActifCard(k, 'base', false)));
    }

    // Ciblage
    if (result.ciblage.length > 0) {
      wrap.appendChild(h('h3', { class: 'pdn-results-section-title' }, 'Ciblage complémentaire'));
      result.ciblage.forEach(k => wrap.appendChild(renderActifCard(k, 'cible', false)));
    }

    // CTAs (footer)
    const footer = h('div', { class: 'pd-footer', style: { gap: '12px', justifyContent: 'center', flexWrap: 'wrap' } });
    footer.appendChild(h('button', {
      class: 'pd-btn pd-btn-ghost',
      type: 'button',
      on: { click: () => { state.mode = 'questions'; state.cursor = PARTIE_2_END; render(); } },
    }, '← Modifier'));
    footer.appendChild(h('button', {
      class: 'pd-btn pd-btn-primary',
      type: 'button',
      on: { click: () => { state.mode = 'bifurcation'; render(); window.scrollTo({ top: 0, behavior: 'smooth' }); } },
    }, 'Continuer →'));
    wrap.appendChild(footer);

    // Mention légale obligatoire
    wrap.appendChild(renderMentionLegale());

    return wrap;
  }

  function renderMentionLegale() {
    return h('p', { class: 'pdn-mention-legale' }, MENTION_LEGALE_TEXT);
  }

  // ============================================================
  // 12. RENDER : BIFURCATION — pd-bifurcation
  // ============================================================
  // V3.34e — Gate mi-parcours motivant : « Votre bilan de base est prêt » +
  // pastille protocole/actifs + 2 CTAs courts (Finaliser / Affiner) hiérarchisés
  // selon state.intro_choice (choisi dès l'intro). Le mode choisi à l'intro =
  // CTA primaire vert clair en haut ; l'autre = ghost en bas. Changer de mode ici
  // émet « Bilan Nutrition Mode Changed » {from, to}. Rétrocompat : si aucun
  // intro_choice (sessions antérieures), on retombe sur l'écran historique.
  function renderBifurcation() {
    if (state.intro_choice) return renderBifurcationGate();
    return renderBifurcationLegacy();
  }

  function renderBifurcationGate() {
    setBgDark(true);
    setRootClass('pd-step6');
    const introMode = state.intro_choice || 'complet';

    const wrap = h('div', { class: 'pd-question pd-step6 pd-bifurcation pdn-step6-v2 pd-fade' });

    wrap.appendChild(h('p', { class: 'pdn-step6-eyebrow' }, 'ÉTAPE 2 SUR 3 · VOTRE BILAN'));

    const frame = h('div', { class: 'pd-bifurcation-frame pdn-step6-frame' });

    frame.appendChild(h('h2', {
      class: 'pdn-step6-title',
      html: 'Votre bilan de base est <em>prêt.</em>',
    }));

    // CTA Finaliser — valide la cure de base telle quelle → loading2 (partiel)
    const buildFinaliser = (variant) => {
      const block = h('div', { class: 'pdn-step6-cta-block' });
      const btn = h('button', {
        class: 'pdn-step6-cta pdn-step6-cta--' + variant,
        type: 'button',
        on: { click: () => {
          try {
            if (introMode !== 'rapide') {
              window._learnq = window._learnq || [];
              window._learnq.push(['track', 'Bilan Nutrition Mode Changed', { from: introMode, to: 'rapide' }]);
            }
          } catch (err) { /* silent */ }
          state.intro_choice = 'rapide';
          state.parcours = 'partiel';
          state.mode = 'loading2';
          render();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } },
      }, 'Finaliser');
      const helper = h('div', { class: 'pdn-step6-cta-helper' });
      helper.appendChild(document.createTextNode('Votre cure de base, validée telle quelle. '));
      helper.appendChild(h('span', { class: 'pdn-step6-cta-time' }, 'immédiat'));
      block.appendChild(btn);
      block.appendChild(helper);
      return block;
    };

    // CTA Affiner — 3 questions de plus → parcours complet (startAffinage)
    const buildAffiner = (variant) => {
      const block = h('div', { class: 'pdn-step6-cta-block' });
      const btn = h('button', {
        class: 'pdn-step6-cta pdn-step6-cta--' + variant,
        type: 'button',
        on: { click: () => {
          try {
            if (introMode !== 'complet') {
              window._learnq = window._learnq || [];
              window._learnq.push(['track', 'Bilan Nutrition Mode Changed', { from: introMode, to: 'complet' }]);
            }
          } catch (err) { /* silent */ }
          state.intro_choice = 'complet';
          startAffinage();
        } },
      }, 'Affiner');
      const helper = h('div', { class: 'pdn-step6-cta-helper' });
      helper.appendChild(document.createTextNode('Quelques questions de plus pour affiner la sélection. '));
      helper.appendChild(h('span', { class: 'pdn-step6-cta-time' }, '~ 1 min'));
      block.appendChild(btn);
      block.appendChild(helper);
      return block;
    };

    // Hiérarchie : le mode choisi à l'intro = primaire en haut, l'autre = ghost en bas
    const ctaWrap = h('div', { class: 'pdn-step6-cta-wrap' });
    if (introMode === 'rapide') {
      ctaWrap.appendChild(buildFinaliser('primary'));
      ctaWrap.appendChild(buildAffiner('ghost'));
    } else {
      ctaWrap.appendChild(buildAffiner('primary'));
      ctaWrap.appendChild(buildFinaliser('ghost'));
    }
    frame.appendChild(ctaWrap);
    wrap.appendChild(frame);

    wrap.appendChild(h('button', {
      class: 'pd-btn pd-btn-ghost pd-back-link',
      type: 'button',
      on: { click: () => { state.mode = 'reveal'; render(); } },
    }, '← Précédent'));

    return wrap;
  }

  function renderBifurcationLegacy() {
    setBgDark(true);
    setRootClass('pd-step6');
    const result = state._result || runScoring(state.answers, 'partial');
    const wrap = h('div', { class: 'pd-question pd-step6 pd-bifurcation pd-fade' });

    wrap.appendChild(h('p', { class: 'pd-bifurcation-eyebrow' }, 'MA PERSONNALISATION'));

    const frame = h('div', { class: 'pd-bifurcation-frame' });
    frame.appendChild(h('h2', {
      class: 'pd-bifurcation-title',
      html: 'Comment souhaitez-vous <em>continuer</em> ?',
    }));
    frame.appendChild(h('p', {
      class: 'pd-bifurcation-subtext',
      html: 'Votre protocole de base ' + result.objectifLabel + ' est <em>prêt</em>. Affinez-le davantage ou validez tel quel.',
    }));
    frame.appendChild(h('button', {
      class: 'pd-btn pd-btn-primary pd-bifurcation-primary',
      type: 'button',
      on: { click: startAffinage },
    }, 'Affiner mon protocole →'));
    frame.appendChild(h('button', {
      class: 'pd-bifurcation-secondary',
      type: 'button',
      on: { click: () => {
        // Parcours partiel : passe par la transition finale (loading2)
        // avant redirection vers la page résultats. Le parcours reste
        // 'partiel' pour que loading2 redirige avec le bon mode.
        state.mode = 'loading2';
        render();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } },
    }, 'Ce protocole me convient'));
    wrap.appendChild(frame);

    wrap.appendChild(h('button', {
      class: 'pd-btn pd-btn-ghost pd-back-link',
      type: 'button',
      on: { click: () => { state.mode = 'reveal'; render(); } },
    }, '← Précédent'));

    return wrap;
  }

  function startAffinage() {
    state.parcours = 'complet';
    state.mode = 'questions';
    state.cursor = PARTIE_2_END + 1;
    render();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // ============================================================
  // 13. RENDER : ACTIF CARD (pdn-actif-card)
  // ============================================================
  function renderActifCard(actifKey, role, withCheckbox) {
    const a = CATALOGUE[actifKey];
    if (!a) return h('div', null, '');
    const remote = _catalogueRemote && _catalogueRemote[a.handle];
    const price = remote ? remote.price : a.prix_indicatif;
    const isChecked = !!state.selectedActifs[actifKey];

    const badgeClass = role === 'base' ? 'pdn-badge-or'
      : role === 'conditionnel' ? 'pdn-badge-orange'
      : 'pdn-badge-blue';
    const badgeLabel = role === 'base' ? 'Base'
      : role === 'conditionnel' ? 'Conditionnel'
      : 'Cible';

    const card = h('div', {
      class: 'pdn-actif-card' + (withCheckbox && isChecked ? ' is-checked' : ''),
    });

    const head = h('div', { class: 'pdn-actif-head' });
    head.appendChild(h('h4', { class: 'pdn-actif-name' }, a.nom));
    head.appendChild(h('span', { class: 'pdn-actif-badge ' + badgeClass }, badgeLabel));
    card.appendChild(head);

    card.appendChild(h('p', { class: 'pdn-actif-product' }, a.produit));
    card.appendChild(h('p', { class: 'pdn-actif-why' }, a.why));

    // Mention obligatoire ferritine pour fer_femme
    if (actifKey === 'fer_femme') {
      card.appendChild(h('div', { class: 'pdn-fer-mention pdn-actif-fer-mention' }, [
        h('span', { class: 'pdn-fer-mention-badge' }, 'Bilan préalable'),
        h('span', { class: 'pdn-fer-mention-text' }, FER_CONDITIONNEL_TEXT),
      ]));
    }

    // Grille 2x2
    const grid = h('div', { class: 'pdn-actif-grid' });
    [
      { label: 'Forme', value: a.forme },
      { label: 'Dosage', value: a.dosage },
      { label: 'Moment', value: a.moment },
      { label: 'Durée', value: a.duree },
    ].forEach(item => {
      const cell = h('div', { class: 'pdn-actif-grid-item' });
      cell.appendChild(h('span', { class: 'pdn-actif-grid-label' }, item.label));
      cell.appendChild(h('span', { class: 'pdn-actif-grid-value' }, item.value));
      grid.appendChild(cell);
    });
    card.appendChild(grid);

    // Meta : prix + checkbox (si applicable)
    const meta = h('div', { class: 'pdn-actif-meta' });
    if (withCheckbox) {
      const lab = h('label', { class: 'pdn-actif-checkbox' });
      lab.appendChild(h('input', {
        type: 'checkbox',
        checked: isChecked ? 'checked' : null,
        'data-actif-key': actifKey,
        on: {
          change: (e) => {
            state.selectedActifs[actifKey] = e.target.checked;
            render();
          },
        },
      }));
      lab.appendChild(h('span', null, 'Inclure dans la cure'));
      meta.appendChild(lab);
    } else {
      meta.appendChild(h('span', { class: 'pdn-actif-checkbox' }, '— Recommandé'));
    }
    meta.appendChild(h('span', { class: 'pdn-actif-price' }, formatPrice(price)));
    card.appendChild(meta);

    return card;
  }

  function formatPrice(p) {
    if (typeof p !== 'number') return '';
    return p.toFixed(2).replace('.', ',') + ' €';
  }

  // ============================================================
  // 14. RENDER : RÉSULTATS COMPLETS
  // ============================================================
  function renderResultsComplete() {
    setBgDark(true);  // garde fond vert avec carte crème centrale
    setRootClass(null);
    const result = runScoring(state.answers, 'complete');
    state._result = result;
    console.log('[Quiz Nutrition] Résultats complets :', result);

    // Init checkboxes
    [...result.baseEssentielle, ...result.ciblage].forEach(k => {
      if (state.selectedActifs[k] === undefined) state.selectedActifs[k] = true;
    });
    result.conditionnels.forEach(k => {
      if (state.selectedActifs[k] === undefined) state.selectedActifs[k] = false;
    });

    const totalActifs = result.baseEssentielle.length + result.ciblage.length + result.conditionnels.length;
    const phases = buildProtocoleP3(result);
    const synergies = computeSynergies(result);
    const interactions = computeInteractions(result);

    const wrap = h('div', { class: 'pd-question pd-fade' });

    // Hero
    const hero = h('div', { class: 'pdn-results-hero', style: { paddingBottom: '20px', borderBottom: '1px solid #efe8dc', marginBottom: '24px' } });
    hero.appendChild(h('div', { class: 'pdn-results-hero-eyebrow' }, 'VOTRE PROTOCOLE PERSONNALISÉ'));
    const heroTitle = h('h1', { class: 'pdn-results-hero-title' });
    heroTitle.appendChild(document.createTextNode('Protocole '));
    const em = document.createElement('em');
    em.textContent = result.objectifLabel;
    heroTitle.appendChild(em);
    heroTitle.appendChild(document.createTextNode(' — ' + totalActifs + ' actifs'));
    hero.appendChild(heroTitle);
    wrap.appendChild(hero);

    // Protocole 3 phases
    const proto = h('div', { class: 'pdn-protocole' });
    proto.appendChild(h('div', { class: 'pdn-protocole-title' }, 'Protocole sur 3 mois'));
    phases.forEach((p, i) => {
      const phase = h('div', { class: 'pdn-phase' });
      phase.appendChild(h('div', { class: 'pdn-phase-num' }, String(i + 1)));
      const body = h('div', { class: 'pdn-phase-body' });
      body.appendChild(h('strong', null, p.titre));
      body.appendChild(h('p', null, p.description));
      phase.appendChild(body);
      proto.appendChild(phase);
    });
    wrap.appendChild(proto);

    // Interactions
    if (interactions.length > 0) {
      wrap.appendChild(h('h3', { class: 'pdn-results-section-title' }, 'Interactions à connaître'));
      interactions.forEach(int => {
        const div = h('div', { class: 'pdn-interaction' });
        div.appendChild(h('strong', null, int.titre));
        div.appendChild(h('span', null, int.detail));
        wrap.appendChild(div);
      });
    }

    // Base essentielle
    wrap.appendChild(h('h3', { class: 'pdn-results-section-title' }, 'Base essentielle'));
    result.baseEssentielle.forEach(k => wrap.appendChild(renderActifCard(k, 'base', true)));

    // Ciblage
    if (result.ciblage.length > 0) {
      wrap.appendChild(h('h3', { class: 'pdn-results-section-title' }, 'Ciblage personnalisé'));
      result.ciblage.forEach(k => wrap.appendChild(renderActifCard(k, 'cible', true)));
    }

    // Conditionnel (fer)
    if (result.conditionnels.length > 0) {
      wrap.appendChild(h('h3', { class: 'pdn-results-section-title' }, 'Option conditionnelle'));
      wrap.appendChild(h('div', { class: 'pdn-notice pdn-notice-warn' },
        'Bilan ferritine recommandé avant cure de fer. Ne pas démarrer sans contrôle médical.'));
      result.conditionnels.forEach(k => wrap.appendChild(renderActifCard(k, 'conditionnel', true)));
    }

    // Synergies
    if (synergies.length > 0) {
      wrap.appendChild(h('h3', { class: 'pdn-results-section-title' }, 'Synergies actives'));
      synergies.forEach(syn => {
        const div = h('div', { class: 'pdn-synergie' });
        div.appendChild(h('strong', null, syn.titre));
        div.appendChild(h('span', null, syn.detail));
        wrap.appendChild(div);
      });
    }

    // Notice teaser
    const teaser = h('div', { class: 'pdn-notice-teaser' });
    teaser.appendChild(h('div', { class: 'pdn-notice-teaser-icon' }, '🔒'));
    teaser.appendChild(h('h3', { class: 'pdn-notice-teaser-title' }, 'Votre notice de cure complète est prête'));
    teaser.appendChild(h('p', { class: 'pdn-notice-teaser-text' },
      'Posologie détaillée, moments de prise, durée, ajustements selon les saisons — débloquée avec votre commande.'));
    wrap.appendChild(teaser);

    // Récap panier
    wrap.appendChild(renderCartRecap(result));

    // Email submit
    if (!state.submittedKlaviyo && state.email) {
      pushToKlaviyo();
      state.submittedKlaviyo = true;
    }

    // Footer back
    const footer = h('div', { class: 'pd-footer', style: { justifyContent: 'center', marginTop: '24px' } });
    footer.appendChild(h('button', {
      class: 'pd-btn pd-btn-ghost',
      type: 'button',
      on: { click: () => { state.mode = 'questions'; state.cursor = PARTIE_3_END; render(); } },
    }, '← Modifier mes réponses'));
    wrap.appendChild(footer);

    // Mention légale obligatoire
    wrap.appendChild(renderMentionLegale());

    return wrap;
  }

  // Récap final calqué sur block_checkout du quiz peau (pd-checkout-* classes) :
  // recap eyebrow + count + titre routine + total estimé + CTA principal +
  // lien email + trust badges + mention pharmacienne + mention légale.
  function renderCartRecap(result) {
    const all = [...result.baseEssentielle, ...result.ciblage, ...result.conditionnels];
    const selectedKeys = all.filter(k => state.selectedActifs[k]);
    let total = 0;
    selectedKeys.forEach(k => {
      const a = CATALOGUE[k];
      const remote = _catalogueRemote && _catalogueRemote[a.handle];
      total += remote ? remote.price : a.prix_indicatif;
    });

    const wrap = h('section', { class: 'pd-block pd-block-checkout pd-checkout-final' });
    const inner = h('div', { class: 'pd-checkout-inner' });

    // Recap line : eyebrow + count
    const recap = h('div', { class: 'pd-checkout-recap' });
    const recapLine = h('div', { class: 'pd-checkout-recap-line' });
    recapLine.appendChild(h('span', { class: 'pd-checkout-eyebrow' }, 'Total protocole'));
    recapLine.appendChild(h('span', { class: 'pd-checkout-count' },
      selectedKeys.length + (selectedKeys.length > 1 ? ' actifs' : ' actif')));
    recap.appendChild(recapLine);
    const titleH = h('h3', { class: 'pd-checkout-routine' });
    titleH.appendChild(document.createTextNode('Protocole '));
    const em = document.createElement('em');
    em.textContent = result.objectifLabel;
    titleH.appendChild(em);
    titleH.appendChild(document.createTextNode(' · 1 mois'));
    recap.appendChild(titleH);
    inner.appendChild(recap);

    // Total estimé
    const totalEst = h('div', { class: 'pd-checkout-total' });
    totalEst.appendChild(h('span', { class: 'pd-checkout-total-label' }, 'Total estimé'));
    totalEst.appendChild(h('span', { class: 'pd-checkout-total-value' },
      total > 0 ? formatPrice(total) : 'Calculé au panier'));
    inner.appendChild(totalEst);

    // Mention fer si fer_femme coché dans la cure
    if (selectedKeys.includes('fer_femme')) {
      inner.appendChild(h('div', { class: 'pdn-fer-mention pdn-cart-fer-mention' }, [
        h('span', { class: 'pdn-fer-mention-badge' }, 'Bilan préalable'),
        h('span', { class: 'pdn-fer-mention-text' }, FER_CONDITIONNEL_TEXT),
      ]));
    }

    // CTA principal — "Ajouter au panier"
    const cta = h('button', {
      class: 'pd-checkout-cta-main',
      type: 'button',
      disabled: selectedKeys.length === 0 ? '' : null,
      on: { click: () => addToCart(result) },
    });
    cta.appendChild(document.createTextNode('Ajouter au panier '));
    cta.appendChild(h('span', { class: 'pd-cta-arrow' }, '→'));
    inner.appendChild(cta);

    // Lien email — "Recevoir mon protocole par email"
    const emailLink = h('a', {
      class: 'pd-checkout-email-link', href: '#', role: 'button',
      on: {
        click: (e) => {
          e.preventDefault();
          if (state.email) {
            pushToKlaviyo();
            showToast('Protocole envoyé à votre email ✓');
          } else {
            showToast('Renseignez votre email pour recevoir le protocole.');
          }
        },
      },
    }, '✉ Recevoir mon protocole par email');
    inner.appendChild(emailLink);

    // Lien recommencer
    const restart = h('a', {
      class: 'pd-checkout-restart-link', href: '#', role: 'button',
      on: {
        click: (e) => {
          e.preventDefault();
          state = defaultState();
          render();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        },
      },
    });
    restart.appendChild(h('span', { class: 'pd-restart-arrow' }, '←'));
    restart.appendChild(document.createTextNode(' Recommencer mon bilan'));
    inner.appendChild(restart);

    wrap.appendChild(inner);

    // Zone trust (fond plus foncé)
    const trust = h('div', { class: 'pd-checkout-trust' });
    const badges = h('div', { class: 'pd-checkout-badges' });
    [
      { text: 'Sauvegardé' },
      { text: 'À vie' },
      { text: 'Point relais offert dès 39 €' },
      { text: 'Retours gratuits' },
    ].forEach(it => {
      badges.appendChild(h('span', { class: 'pd-trust-badge' }, it.text));
    });
    trust.appendChild(badges);

    trust.appendChild(h('div', { class: 'pd-checkout-pharma' },
      '— Une pharmacienne derrière chaque protocole —'));

    const legal = h('p', { class: 'pd-checkout-legal' });
    legal.appendChild(document.createTextNode(
      'Ce bilan micro-nutrition est réalisé par une pharmacienne et ne constitue pas un diagnostic médical. En cas de pathologie, consultez un médecin. '
    ));
    legal.appendChild(h('a', { href: '/pages/mentions-legales' }, 'Mentions légales'));
    trust.appendChild(legal);

    wrap.appendChild(trust);
    return wrap;
  }

  // ============================================================
  // 15. PROTOCOLE 3 PHASES, SYNERGIES, INTERACTIONS
  // ============================================================
  function buildProtocoleP3(result) {
    const all = [...result.baseEssentielle, ...result.ciblage, ...result.conditionnels];
    const m1Names = all.slice(0, 2).map(k => CATALOGUE[k] && CATALOGUE[k].nom).filter(Boolean).join(', ');
    return [
      {
        titre: 'Mois 1 — Stabilisation',
        description: 'Démarrage progressif sur la base essentielle (' + m1Names + '). Premiers signaux observés à 2-3 semaines.',
      },
      {
        titre: 'Mois 2 — Renforcement',
        description: 'Ajout des actifs de ciblage. Pleine efficacité du protocole sur l\'objectif principal.',
      },
      {
        titre: 'Mois 3 — Consolidation',
        description: 'Maintien du protocole complet. Bilan en fin de mois 3 pour ajuster ou interrompre les actifs ciblés.',
      },
    ];
  }

  function computeSynergies(result) {
    const all = new Set([...result.baseEssentielle, ...result.ciblage, ...result.conditionnels]);
    const out = [];
    if (all.has('vitamine_d') && all.has('magnesium')) out.push({
      titre: 'Vitamine D + Magnésium',
      detail: 'Le magnésium est un co-facteur de l\'activation de la vitamine D — l\'une des associations les plus efficaces.',
    });
    if (all.has('zinc') && all.has('vitamine_c')) out.push({
      titre: 'Zinc + Vitamine C',
      detail: 'Synergie immunitaire reconnue : la vitamine C améliore l\'absorption du zinc.',
    });
    if (all.has('omega3') && all.has('vitamine_d')) out.push({
      titre: 'Oméga-3 + Vitamine D',
      detail: 'Les oméga-3 améliorent la biodisponibilité de la vitamine D liposoluble.',
    });
    if (all.has('coq10') && all.has('vitamine_b')) out.push({
      titre: 'CoQ10 + Vitamines B',
      detail: 'Les vitamines B activent le cycle énergétique mitochondrial soutenu par le CoQ10.',
    });
    if (all.has('inositol') && all.has('vitex')) out.push({
      titre: 'Inositol + Vitex',
      detail: 'Couple de référence pour l\'équilibre hormonal féminin et la régulation des cycles.',
    });
    return out;
  }

  function computeInteractions(result) {
    const all = new Set([...result.baseEssentielle, ...result.ciblage, ...result.conditionnels]);
    const out = [];
    if (all.has('zinc') && all.has('fer_femme')) out.push({
      titre: 'Zinc et fer : prises décalées',
      detail: 'Compétition d\'absorption. Prendre l\'un le matin, l\'autre le soir, ou à 4h d\'intervalle.',
    });
    if (all.has('calcium') && all.has('fer_femme')) out.push({
      titre: 'Calcium et fer : prises décalées',
      detail: 'Le calcium réduit l\'absorption du fer de 40%. Décaler les prises de 2h minimum.',
    });
    if (all.has('curcuma')) out.push({
      titre: 'Curcuma : à prendre avec un repas gras',
      detail: 'Liposoluble. Sa biodisponibilité s\'effondre à jeun.',
    });
    return out;
  }

  // ============================================================
  // 16. NAVIGATION
  // ============================================================
  function onSelect(q, value) {
    if (q.type === 'single') {
      state.answers[q.id] = value;
      render();
      if (!q.noAutoAdvance) {
        if (_advanceTimer) clearTimeout(_advanceTimer);
        _advanceTimer = setTimeout(() => { _advanceTimer = null; goNext(); }, AUTOADV_DELAY);
      }
      return;
    }
    // multi/chips
    const current = Array.isArray(state.answers[q.id]) ? state.answers[q.id].slice() : [];
    const aucun = q.aucunKey;
    if (aucun && value === aucun) {
      if (current.includes(aucun)) state.answers[q.id] = [];
      else state.answers[q.id] = [aucun];
      render();
      return;
    }
    let next = current.filter(v => v !== aucun);
    const idx = next.indexOf(value);
    if (idx !== -1) next.splice(idx, 1);
    else if (q.max && next.length >= q.max) {} // max
    else next.push(value);
    state.answers[q.id] = next;
    render();
  }

  function goNext() {
    const q = getCurrentQuestion();
    if (!isAnswerValid(q)) return;

    if (state.cursor === PARTIE_2_END) {
      state.mode = 'email';
      render();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    if (state.cursor === PARTIE_3_END) {
      state.mode = 'loading2';
      render();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    state.cursor++;
    render();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function goPrev() {
    if (state.mode === 'email') { state.mode = 'questions'; state.cursor = PARTIE_2_END; render(); return; }
    if (state.mode === 'loading1') { state.mode = 'email'; render(); return; }
    if (state.mode === 'reveal') { state.mode = 'email'; render(); return; }
    if (state.mode === 'bifurcation') { state.mode = 'reveal'; render(); return; }
    if (state.mode === 'results-partial') { state.mode = 'bifurcation'; render(); return; }
    if (state.mode === 'loading2') { state.mode = 'questions'; state.cursor = PARTIE_3_END; render(); return; }
    if (state.mode === 'results-complete') { state.mode = 'questions'; state.cursor = PARTIE_3_END; render(); return; }
    if (state.cursor > 0) { state.cursor--; render(); window.scrollTo({ top: 0, behavior: 'smooth' }); }
  }

  // ============================================================
  // 17. CART, KLAVIYO, STOREFRONT
  // ============================================================
  function addToCart(result) {
    const all = [...result.baseEssentielle, ...result.ciblage, ...result.conditionnels]
      .filter(k => state.selectedActifs[k]);
    if (all.length === 0) { showToast('Aucun actif sélectionné.'); return; }
    // Attributs panier :
    //  - from_bilan_nutrition : variant detection emails post-achat (Liquid)
    //  - _pd_bilan : bilan calculé (JSON sessionStorage enrichi du profil),
    //    relu par la notice nutrition dans l'espace membre post-achat.
    var _bilanAttr = '';
    try {
      var _raw = sessionStorage.getItem(SS_BILAN_KEY);
      if (_raw) {
        var _obj = JSON.parse(_raw);
        if (result && result.profil) _obj.profil = result.profil;
        _bilanAttr = JSON.stringify(_obj);
      }
    } catch (e) { _bilanAttr = ''; }
    fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { from_bilan_nutrition: 'true', _pd_bilan: _bilanAttr } }),
    }).catch(function () {});
    Promise.all(all.map(k => lookupVariant(CATALOGUE[k].handle)))
      .then(variants => {
        const items = variants.filter(v => v && v.variantId).map(v => ({
          id: v.variantId, quantity: 1,
          // _pd_via : marque chaque actif ajouté via le bilan nutrition. Signal
          // per-commande pour la variante des emails Shopify (masqué côté client
          // par le préfixe « _ », conservé sur la commande, lisible en Liquid).
          properties: { '_pd_via': 'bilan_nutrition' },
        }));
        if (items.length === 0) { showToast('Impossible de récupérer les produits.'); return; }
        return fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        }).then(r => {
          if (!r.ok) throw new Error('cart/add failed');
          showToast(items.length + ' actifs ajoutés ✓ Voir mon panier →', '/cart');
        });
      })
      .catch(err => {
        console.error('[Quiz Nutrition] Erreur panier :', err);
        showToast('Erreur lors de l\'ajout au panier.');
      });
  }

  function lookupVariant(handle) {
    const cached = _catalogueRemote && _catalogueRemote[handle];
    if (cached && cached.variantId) return Promise.resolve(cached);
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(r => r.ok ? r.json() : null)
      .then(d => {
        if (!d || !d.variants || !d.variants[0]) return null;
        const v = d.variants[0];
        return { variantId: v.id, price: v.price / 100, title: d.title };
      })
      .catch(() => null);
  }

  function showToast(message, link) {
    const existing = document.querySelector('.pdn-toast');
    if (existing) existing.remove();
    const toast = h('div', { class: 'pdn-toast' });
    toast.appendChild(document.createTextNode(message));
    if (link) {
      toast.appendChild(h('a', { href: link }, 'Voir →'));
    }
    document.body.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    setTimeout(() => {
      toast.classList.remove('is-visible');
      setTimeout(() => toast.remove(), 400);
    }, 4000);
  }

  function pushToKlaviyo() {
    const result = state._result;
    if (!result || !state.email) return;
    // Construit la liste actifs_recommandes en marquant fer_femme avec un
    // suffixe explicite "fer_femme:bilan_prealable_obligatoire" pour que
    // les automations Klaviyo puissent appliquer un wording adapté.
    const allActifs = [...result.baseEssentielle, ...result.ciblage, ...result.conditionnels];
    const actifsRecommandes = allActifs.map(k =>
      k === 'fer_femme' ? 'fer_femme:bilan_prealable_obligatoire' : k);
    const props = {
      objectif_principal: state.answers.Q6 || null,
      objectif_secondaire: state.answers.Q11 || null,
      genre: state.answers.Q3 || null,
      age: state.answers.Q4 || null,
      actifs_recommandes: actifsRecommandes,
      ci_detectees: result.ci || [],
      dejapris: state.answers.Q5 || [],
      score_personnalisation: result.mode === 'complete' ? 'complet' : 'partiel',
      depuis_quiz_peau: state.depuisQuizPeau === true,
    };
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', { $email: state.email, $first_name: state.firstName, bilan_nutrition_complete: true }]);
      window._learnq.push(['track', 'Bilan Micro-Nutrition Complété', props]);
      console.log('[Quiz Nutrition] Klaviyo event envoyé :', props);
    } catch (e) {
      console.error('[Quiz Nutrition] Klaviyo push failed :', e);
    }
  }

  function loadStorefrontCatalogue() {
    const token = window.PARADERMIA_NUTRITION_STOREFRONT_TOKEN;
    const shop = window.Shopify && window.Shopify.shop;
    if (!token || !shop) {
      console.log('[Quiz Nutrition] Storefront non configuré, fallback /products/{handle}.js par actif.');
      return Promise.resolve(null);
    }
    const handles = Object.values(CATALOGUE).map(a => a.handle);
    const query = `
      query getProducts($q: String) {
        products(first: 50, query: $q) {
          edges { node {
            handle title
            variants(first: 1) { edges { node { id price { amount } } } }
            metafield(namespace: "custom", key: "actif_key") { value }
          } }
        }
      }`;
    return fetch('https://' + shop + '/api/2024-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token,
      },
      body: JSON.stringify({ query, variables: { q: handles.map(h => 'handle:' + h).join(' OR ') } }),
    })
      .then(r => r.json())
      .then(data => {
        const edges = (data && data.data && data.data.products && data.data.products.edges) || [];
        const map = {};
        edges.forEach(e => {
          const n = e.node;
          const v = n.variants.edges[0] && n.variants.edges[0].node;
          if (!v) return;
          map[n.handle] = {
            variantId: parseInt(v.id.replace(/\D/g, ''), 10),
            price: parseFloat(v.price.amount),
            title: n.title,
            actifKey: n.metafield && n.metafield.value,
          };
        });
        _catalogueRemote = map;
        console.log('[Quiz Nutrition] Catalogue Storefront chargé :', Object.keys(map).length, 'actifs');
      })
      .catch(err => console.warn('[Quiz Nutrition] Storefront fetch failed :', err));
  }

  // ============================================================
  // 18. RENDER ROOT + MOUNT
  // ============================================================
  function render() {
    if (!app || !app.root) return;
    app.root.innerHTML = '';
    let view;
    switch (state.mode) {
      case 'sas': view = renderSas(); break;
      case 'questions': view = renderQuestionView(); break;
      case 'email': view = renderEmailCapture(); break;
      case 'loading1': view = renderLoading1(); break;
      case 'reveal': view = renderReveal(); break;
      case 'bifurcation': view = renderBifurcation(); break;
      case 'results-partial': view = renderResultsPartial(); break;
      case 'loading2': view = renderLoading2(); break;
      case 'results-complete': view = renderResultsComplete(); break;
    }
    if (view) app.root.appendChild(view);
  }

  function mountQuiz(root) {
    state = defaultState();
    applyUrlPrefill();
    app = { root, render };
    loadStorefrontCatalogue().finally(() => render());
    render();
  }

  // ============================================================
  // 19. TESTS — 3 PROFILS
  // ============================================================
  function runTestProfiles() {
    console.group('[Quiz Nutrition] === TESTS 3 PROFILS — sessionStorage payload ===');

    function bilanFor(answers, mode) {
      const result = runScoring(answers, mode);
      const addons = computeAddons(result, answers);
      return {
        objectif_principal:  OBJECTIF_LABELS[answers.Q6] || result.objectifLabel,
        objectif_secondaire: answers.Q11 && answers.Q11 !== 'aucun' ? (OBJECTIF_LABELS[answers.Q11] || answers.Q11) : null,
        genre: answers.Q3, age: answers.Q4,
        actifs_base:         result.baseEssentielle,
        actifs_cible:        result.ciblage,
        actifs_conditionnel: result.conditionnels,
        actifs_addon:        addons,
        ci_detectees:        result.ci,
        dejapris:            answers.Q5 || [],
        depuis_quiz_peau:    false,
        forme_galenique:     answers.Q5b || null,
      };
    }

    const p1 = {
      Q1:['aucune'], Q2:['aucun'], Q3:'femme', Q4:'35-44', Q5:['aucun'], Q5b:'gelules',
      Q6:'sommeil', Q7:'avant_6h', Q8:'legere', Q9:'vegan', Q10:'2-4',
      Q11:'energie', Q12:'parfois', Q13:['tensions'], Q14:'aucun', Q15:'cycle_reg',
    };
    console.log('PROFIL 1 — Femme 35-44 vegan sommeil :', JSON.stringify(bilanFor(p1, 'complete'), null, 2));

    const p2 = {
      Q1:['aucune'], Q2:['aucun'], Q3:'homme', Q4:'45-54', Q5:['aucun'], Q5b:'peu_importe',
      Q6:'energie', Q7:'6h_7h30', Q8:'coup_barre', Q9:'omnivore_eq', Q10:'>7',
      Q11:'sport', Q12:'rarement', Q13:['tensions','irritabilite'], Q14:'aucun', Q15:'dig_ok',
    };
    console.log('PROFIL 2 — Homme 45-54 énergie sport intensif :', JSON.stringify(bilanFor(p2, 'complete'), null, 2));

    const p3 = {
      Q1:['enceinte'], Q2:['aucun'], Q3:'femme', Q4:'25-34', Q5:['aucun'], Q5b:'gelules',
      Q6:'energie', Q7:'avant_6h', Q8:'epuisement', Q9:'omnivore_eq', Q10:'<2',
      Q11:'aucun', Q12:'parfois', Q13:['tensions','palpitations','irritabilite','bruxisme'],
      Q14:'tres_seche', Q15:'cycle_reg',
    };
    const r3Full = bilanFor(p3, 'complete');
    console.log('PROFIL 3 — Femme enceinte (vérif CI) :', JSON.stringify(r3Full, null, 2));
    const ok = ['ashwagandha','tribulus_maca','vitex'].every(k => r3Full.ci_detectees.includes(k));
    console.log(ok ? '✓ CI grossesse OK' : '✗ CI grossesse manquante');

    console.groupEnd();
    return { p1: bilanFor(p1, 'complete'), p2: bilanFor(p2, 'complete'), p3: bilanFor(p3, 'complete') };
  }

  // ============================================================
  // 20. BOOTSTRAP
  // ============================================================
  if (typeof document !== 'undefined') {
    document.addEventListener('DOMContentLoaded', () => {
      const root = document.querySelector('[data-quiz-nutrition-root]');
      if (root) mountQuiz(root);
      if (window.location.search.indexOf('test=1') !== -1) runTestProfiles();
    });
  }

  if (typeof window !== 'undefined') {
    window.ParaDermiaNutritionQuiz = {
      mountQuiz, runTestProfiles, runScoring, CATALOGUE,
    };
  }

  // Export for Node.js test harness (no-op in browser)
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { CATALOGUE, OBJECTIF_LABELS, runScoring, computeAddons };
  }
})();

